import React, {useEffect, useRef} from 'react';
import './paymentView.css';
import {useSelector, useDispatch} from 'react-redux';
import {includeInsuranceBalanceNoteUpdate} from '../actions';
import {showOtherInputFieldsTrue, showOtherInputFieldsFalse} from '../actions';
import {showBillingAddressDropTrue, showBillingAddressDropFalse} from '../actions';
import {showBillingAddressFieldsTrue, showBillingAddressFieldsFalse} from '../actions';
import {css_insAdd, css_insRemove} from '../actions';
import {message6DisplayPropertyDisplay, message6DisplayPropertyHide} from '../actions';
import {message8DisplayPropertyDisplay, message8DisplayPropertyHide} from '../actions';
import {payRemainingBalanceValue} from '../actions';
import {minimumPaymentAmountValue} from '../actions';
import {bookingDueTodayAnswer} from '../actions';
import {paymentOptionFull, paymentOptionOther, paymentOptionClear} from '../actions';
import {paymentAmountUpdater} from '../actions';
import {totalcostset} from '../actions';
import {paidInFullLanguageUpdater} from '../actions';
import {insuranceStatusIncluded, insuranceStatusNotIncluded, insuranceStatusPaymentRequired} from '../actions';
import {insuranceVendorLeisure, insuranceVendorOther} from '../actions';
import {remainingBalanceNegativeTrue} from '../actions';
import {bookingPastDueTrue} from '../actions';
import {balanceDueTrue} from '../actions';
import {remainingBalanceSet} from '../actions';
import {remainingBalanceAsFloatSet} from '../actions';
import {paymentDueSet} from '../actions';
import {paymentOtherUpdate} from '../actions';
import {paymentOtherActiveTrue, paymentOtherActiveFalse} from '../actions';
import {scheduledPaymentHasChangedTrue} from '../actions';
import {confirmViewUpdate} from '../actions';
import {ccBillingAddressForVerificationUpdate} from '../actions';
import {cssAddress1Update, cssAddress2Update} from '../actions';
import {cssCityUpdate} from '../actions';
import {cssPaymentStateUpdate} from '../actions';
import {cssZipUpdate} from '../actions';
import {ccMonthUpdate} from '../actions';
import {ccYearUpdate} from '../actions';
import {confirmViewFuturePaymentsUpdate} from '../actions';
import {confirmViewRemainingBalanceUpdate} from '../actions';
import {ccHolderForVerificationNameUpdate} from '../actions';
import {balancePayRemainingValue} from '../actions';
import Popup from 'reactjs-popup';
import {DateTime} from 'luxon';
import NumberFormat from 'react-number-format';
import {noCase} from "change-case";


function getFormattedDate(dateToFormat) {
	let formattedDate = DateTime.fromISO(dateToFormat).toLocaleString(DateTime.DATE_FULL);
	return formattedDate;
}

function isPastDue(checkDate){
	let currentDate = DateTime.now();
	let dueDateasDate=DateTime.fromISO(checkDate);
	if(dueDateasDate<currentDate){
		return true;
	}
	else{return false;}
}
function isDueToday(checkToday){
	let currentDate = Date.now();
	let dueDateasDate2=new Date(checkToday);
	if(dueDateasDate2!==currentDate){
		return false;
	}
	else{return true;}
}

/* Spinner for Ajax calls */
function ajaxSpinnerShow() {
	 document.getElementById("ajaxLoadText").innerHTML = "loading";
	 document.getElementById("ajaxShim").style.display = "block";
	 document.getElementById("ajaxSpinnerOuter").style.display = "block";
	 document.getElementById("ajaxSpinner").style.display = "block";
 }	
 
 function ajaxSpinnerHide() {
	 document.getElementById("ajaxSpinner").style.display = "none";
	 document.getElementById("ajaxSpinnerOuter").style.display = "none";
	 document.getElementById("ajaxShim").style.display = "none";
 }

function PaymentView(props) {   
     
     
     //initial sets
	const showOtherInputFields = useSelector(state => state.showOtherInputFields);
    const showBillingAddressDrop = useSelector(state => state.showBillingAddressDrop);
    const showBillingAddressFields = useSelector(state => state.showBillingAddressFields);
    const css_ins = useSelector(state => state.css_ins);
    const message6DisplayProperty = useSelector(state => state.message6DisplayProperty);
    const insuranceStatus = useSelector(state => state.insuranceStatus);
    const insuranceVendor = useSelector(state => state.insuranceVendor);
    const remainingBalanceNegative = useSelector(state => state.remainingBalanceNegative);
    const bookingPastDue = useSelector(state => state.bookingPastDue);
    const balanceDue = useSelector(state => state.balanceDue);
    const remainingBalance = useSelector(state => state.remainingBalance);
    const paymentDue = useSelector(state => state.paymentDue);
    const payRemainingBalance = useSelector(state => state.payRemainingBalance);
    const minimumPaymentAmount = useSelector(state => state.minimumPaymentAmount);
    const paymentOption = useSelector(state => state.paymentOption);
    const paymentAmount = useSelector(state => state.paymentAmount);
    const paidInFullLanguage = useSelector(state => state.paidInFullLanguage);
    const totalcost = useSelector(state => state.totalcost);
    const insuranceBalanceNote = useSelector(state => state.insuranceBalanceNote);
    const paymentOther = useSelector(state => state.paymentOther);
    const message8DisplayProperty = useSelector(state => state.message8DisplayProperty);
    const scheduledPaymentHasChanged = useSelector(state => state.scheduledPaymentHasChanged);
    const ccBillingAddressForVerification = useSelector(state => state.ccBillingAddressForVerification);
    const css_address1 = useSelector(state => state.css_address1);
    const css_address2 = useSelector(state => state.css_address2);
    const css_city = useSelector(state => state.css_city);
    const css_paymentState = useSelector(state => state.css_paymentState);
    const css_zip = useSelector(state => state.css_zip);
    const ccMonth = useSelector(state => state.ccMonth);
    const ccYear = useSelector(state => state.ccYear);
    const confirmViewFuturePayments = useSelector(state => state.confirmViewFuturePayments);
    const confirmViewRemainingBalance = useSelector(state => state.confirmViewRemainingBalance);
    const ccHolderForVerificationName = useSelector(state => state.ccHolderForVerificationName);

     const dispatch = useDispatch();
     useEffect(() => {
    	 dispatch(totalcostset(Number(props.updateBooking.bookingSummary.charges.totalCost)));
    	 if(props.updateBooking.bookingSummary.charges.insurance.include===true){
    		 dispatch(insuranceStatusIncluded());
    		 if(props.updateBooking.bookingSummary.charges.insurance.vendor.name === "LEISURECARE") {
    			 	dispatch(insuranceVendorLeisure());
				}
				else{
					dispatch(insuranceVendorOther(props.updateBooking.bookingSummary.charges.insurance.vendor.name));
				}
         }
         else{
        	 dispatch(insuranceStatusNotIncluded());
         }    	 if(props.updateBooking.bookingSummary.charges.remainingBalance.toString().indexOf("-")>=0){
    		 dispatch(remainingBalanceNegativeTrue());
         }
    	 if(isPastDue(props.updateBooking.bookingSummary.charges.paymentDueDate)===true){    		 
    		 dispatch(bookingPastDueTrue());
    	 }
    	 if(remainingBalanceNegative===false && props.updateBooking.bookingSummary.charges.remainingBalance!==0){
         	dispatch(balanceDueTrue());
         	dispatch(remainingBalanceSet(props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments));
         	dispatch(remainingBalanceAsFloatSet(props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments));         	
             if (isPastDue(props.updateBooking.bookingSummary.charges.paymentDueDate)===false){
				if (props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking River' && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking Ocean') {
					dispatch(paymentDueSet("Payment due " + getFormattedDate(props.updateBooking.bookingSummary.charges.paymentDueDate)));
				}
     		}
         }
    	 if(props.updateBooking.makePayment.paymentOptions.hasOwnProperty('payRemainingBalance')){
	    	 if(props.updateBooking.makePayment.paymentOptions.payRemainingBalance!==null && props.updateBooking.makePayment.paymentOptions.payRemainingBalance!=='' && typeof(props.updateBooking.makePayment.paymentOptions.payRemainingBalance)!=="undefined"){
	    		 dispatch(payRemainingBalanceValue(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
	    		 dispatch(balancePayRemainingValue(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
	    	}
    	 }
    	 if(props.updateBooking.makePayment.paymentOptions.hasOwnProperty('makeMinimumPayment')){
	    	 if(props.updateBooking.makePayment.paymentOptions.makeMinimumPayment!==null && props.updateBooking.makePayment.paymentOptions.makeMinimumPayment!=='' && typeof(props.updateBooking.makePayment.paymentOptions.makeMinimumPayment)!=="undefined"){
	     		dispatch(minimumPaymentAmountValue(props.updateBooking.makePayment.paymentOptions.makeMinimumPayment));
	     	}
    	 }
    	 dispatch(bookingDueTodayAnswer(isDueToday(props.updateBooking.bookingSummary.charges.paymentDueDate)));
    	 if(props.updateBooking.makePayment.paymentOptions.hasOwnProperty('payRemainingBalance')){
	    	if(props.updateBooking.makePayment.paymentOptions.payRemainingBalance>=props.updateBooking.makePayment.paymentOptions.makeMinimumPayment && isPastDue(props.updateBooking.bookingSummary.charges.paymentDueDate)===false && isDueToday(props.updateBooking.bookingSummary.charges.paymentDueDate)===false){
	    		dispatch(paymentAmountUpdater(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
	     	}
	     	else if((props.updateBooking.makePayment.paymentOptions.payRemainingBalance>=props.updateBooking.makePayment.paymentOptions.makeMinimumPayment && isPastDue(props.updateBooking.bookingSummary.charges.paymentDueDate)===false && isDueToday(props.updateBooking.bookingSummary.charges.paymentDueDate)===true) || (props.updateBooking.makePayment.paymentOptions.payRemainingBalance===0 && props.updateBooking.bookingSummary.quoteInsuranceInd==='Y')) {
	     		dispatch(paymentAmountUpdater(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
	     	}
	     	else if (isPastDue(props.updateBooking.bookingSummary.charges.paymentDueDate)===true) {
	     		dispatch(paymentAmountUpdater(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
	     	}
    	 }
     }, [dispatch]);
     let stateListComplete = '';
     let url = '/wthrest/customer-self-service/getStates.rs';
     fetch(url, {
         method: 'GET',
         headers: {
             'Accept': 'application/json',
             'Content-Type': 'application/json'
         }
     }).then(stateResponse => stateResponse.json()).then(stateResponse => {
    	 stateListComplete = setStateList(stateResponse);
     }).catch(error => {
         console.log("state call failed")
     });
     
     function setStateList(stateListResponse){
    	 while (document.getElementById("css_paymentState").firstChild) {
    		 document.getElementById("css_paymentState").removeChild(document.getElementById("css_paymentState").firstChild);
    	    }    	 
    	 let blankStateOption = document.createElement("option");
    	 blankStateOption.value = '';
    	 document.getElementById("css_paymentState").appendChild(blankStateOption);
    	 Object.keys(stateListResponse.states).forEach(function(key){
    		 let newState = document.createElement("option");
    		 newState.value=stateListResponse.states[key].code;
    		 newState.innerHTML = stateListResponse.states[key].code;
    		 document.getElementById("css_paymentState").appendChild(newState);
    	 });
    	 
     }

     
     function otherAmountChange() {
    	if(document.getElementById("otherAmountPaymentInputField").value){
    		 dispatch(paymentOtherUpdate(document.getElementById("otherAmountPaymentInputField").value));
    	 }
		let customerValue = document.getElementById("otherAmountPaymentInputField").value;
		if(document.getElementById("otherAmountPaymentInputField").value!==null && document.getElementById("otherAmountPaymentInputField").value !==''){
				customerValue = document.getElementById("otherAmountPaymentInputField").value.replace(/,/g, '');
			}
		dispatch(paymentAmountUpdater(customerValue));
    	}
     
     
     function ccHolderOnChange() {
    	 	let setVal = document.getElementById("customerNumber").value;
			if(setVal !=='' && setVal !== 'undefined' && setVal !== null){
				dispatch(ccHolderForVerificationNameUpdate(document.getElementById("css_paxChoice_" + setVal).innerHTML));
			}
			else{
				dispatch(ccHolderForVerificationNameUpdate(''));
			}
			if(setVal === '' || typeof setVal === 'undefined'){
				dispatch(showOtherInputFieldsFalse());
				dispatch(showBillingAddressDropFalse());
				dispatch(showBillingAddressFieldsFalse());
				if(document.getElementById("css_cc_otherFirstName")){
					document.getElementById("css_cc_otherFirstName").value='';
					document.getElementById("css_cc_otherLastName").value='';
					document.getElementById("css_cc_otherMI").value='';
					document.getElementById("css_address1").value='';
					document.getElementById("css_address2").value='';
					document.getElementById("css_city").value='';
					document.getElementById("css_paymentState").value='';
					document.getElementById("css_zip").value='';
				}
			}
			else if (setVal === 'other'){
				dispatch(showOtherInputFieldsTrue());
				dispatch(showBillingAddressDropFalse());
				dispatch(showBillingAddressFieldsTrue());
			}
			else {		
				dispatch(showOtherInputFieldsFalse());
				if(document.getElementById("css_cc_otherFirstName")){
					document.getElementById("css_cc_otherFirstName").value='';
					document.getElementById("css_cc_otherLastName").value='';
					document.getElementById("css_cc_otherMI").value='';
					document.getElementById("css_address1").value='';
					document.getElementById("css_address2").value='';
					document.getElementById("css_city").value='';
					document.getElementById("css_paymentState").value='';
					document.getElementById("css_zip").value='';
				}
				dispatch(showBillingAddressDropTrue());
				dispatch(showBillingAddressFieldsFalse());
				 setTimeout(() => {
					 document.getElementById('customerAddressNumber').innerHTML = "";
					 document.getElementById('customerAddressNumber').innerHTML = "<option value='' selected='selected'>Choose billing address</option>";
					 Object.keys(props.updateBooking.makePayment.creditCardHolderList).forEach(function(key){
							let valueFirstName = props.updateBooking.makePayment.creditCardHolderList[key].firstName;
							let valueLastName = props.updateBooking.makePayment.creditCardHolderList[key].lastName;
							let valueName = valueFirstName.toLowerCase() + " " + valueLastName.toLowerCase();
							//eslint-disable-next-line
							if(props.updateBooking.makePayment.creditCardHolderList[key].customerNumber == setVal || valueName == setVal.toLowerCase()){		
								Object.keys(props.updateBooking.makePayment.creditCardHolderList[key].addresseList).forEach(function(key2){
									if(props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2 === null || props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2 === ''){
										props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2='';
									}
									else{
										if (props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2.slice(-1) !== ",")
											{
												props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2=props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2 + ', ';
											}
									}
									if(props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address1 !== ''){
										document.getElementById('customerAddressNumber').innerHTML += "<option value='" + props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].addressNumber + "' id='css_addressChoice_" + props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].addressNumber + "' >" + props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address1 + ", " + props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2 + props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].city + ", " + props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].state + " " + props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].zipCode + "</option>";
									}
								});

								document.getElementById('customerAddressNumber').innerHTML += "<option value='new'>Enter a new billing address</option>";							
							}
						});
					
					 document.getElementById('customerAddressNumber').value='';
						if(document.getElementById("customerAddressNumber")){
							document.getElementById("customerAddressNumber").value = '';
						}
				 }, 500);
				
			}
			
		
		}
     
     function ccBillingAddressOnChange(setValue) {
    	 dispatch(ccBillingAddressForVerificationUpdate(setValue));
			if(setValue!=='new' && setValue!=='' && typeof(setValue) !== 'undefined'){
				dispatch(ccBillingAddressForVerificationUpdate(document.getElementById("css_addressChoice_" + setValue).innerHTML));
			}
			document.getElementById('customerAddressNumber').value='';
			document.getElementById('customerAddressNumber').value=setValue;	
			
			if(setValue === '' || typeof(setValue) === 'undefined'){
				if(document.getElementById("css_address1")){
					document.getElementById("css_address1").value='';
					document.getElementById("css_address2").value='';
					document.getElementById("css_city").value='';
					document.getElementById("css_paymentState").value='';
					document.getElementById("css_zip").value='';
				}
				dispatch(showBillingAddressFieldsFalse());
			}
			else if(setValue === 'new'){
				dispatch(showBillingAddressFieldsTrue());
			}
			else{	
				if(document.getElementById("css_address1")){
					document.getElementById("css_address1").value='';
					document.getElementById("css_address2").value='';
					document.getElementById("css_city").value='';
					document.getElementById("css_paymentState").value='';
					document.getElementById("css_zip").value='';
				}
				dispatch(showBillingAddressFieldsFalse());
								
			}
		}
     function populateYear(month) {
		let today = DateTime.now();
		let currentMonth = today.month;
		let dropdownValues = "<option value=''>Year</option>";
		let startYear = '';
		if(parseInt(month) < currentMonth) {
			for(let i=0;i<20;i++){
				startYear = today.year + i + 1;					
				dropdownValues = dropdownValues + "<option value='" + startYear + "'>" + startYear + "</option>";
			}
		}
		else {
			for(let i=0;i<20;i++){
				startYear = today.year + i;
				dropdownValues = dropdownValues + "<option value='" + startYear + "'>" + startYear + "</option>";	
			}
		}
		document.getElementById("ccYear").innerHTML=dropdownValues;
	}
     function popYear() {
    	let month = document.getElementById("ccMonth").value;
		if(month === '' || month === 'undefined' || month === null){
				document.getElementById("ccYear").innerHTML("");
			}
			else{
				populateYear(parseInt(month));			
			}
		}
     function clearOtherField(){
			document.getElementById('otherAmountPaymentInputField').value = '';
			dispatch(paymentOtherUpdate(""));
		}
     function changePaymentChoiceOther(){
			otherAmountChange("");
			otherAmountChange(paymentOther);
			dispatch(paymentOptionOther());
			document.getElementById('css_remainingBalancePaymentLabel').classList.remove('wth2_css_radio_selected');
			document.getElementById('css_remainingBalancePaymentLabel').classList.add('wth2_css_radio_notselected');
			document.getElementById('css_otherAmountPaymentLabel').classList.remove('wth2_css_radio_notselected');
			document.getElementById('css_otherAmountPaymentLabel').classList.add('wth2_css_radio_selected');
			document.getElementById('css_remainingBalancePayment').checked=false;
			document.getElementById('css_otherAmountPayment').checked=true;

			if(document.getElementById("css_amountPaidContainer")){
				document.getElementById("css_amountPaidContainer").style.display = 'none';
			}
			
			dispatch(paymentOtherActiveTrue());
			dispatch(paymentAmountUpdater(0));
		}
     function changePaymentChoiceFull(){
	    	 if(document.getElementById("css_otherAmountPayment")){
				otherAmountChange("");
				otherAmountChange(paymentOther);
	    	 }
			 if(document.getElementById("css_amountPaidContainer")){
				document.getElementById("css_amountPaidContainer").style.display = 'none';
			 }
			dispatch(paymentOptionFull());
			//timeout to safely handle paid in full bookings that need to display payment form after insurance addition
			setTimeout(function(){ 
				if(document.getElementById('css_remainingBalancePaymentLabel')){
					document.getElementById('css_remainingBalancePaymentLabel').classList.add('wth2_css_radio_selected');
				}
				if(document.getElementById('css_remainingBalancePaymentLabel')){
					document.getElementById('css_remainingBalancePaymentLabel').classList.remove('wth2_css_radio_notselected');
				}
				if(document.getElementById("css_otherAmountPayment")){
					document.getElementById('css_otherAmountPaymentLabel').classList.add('wth2_css_radio_notselected');
					document.getElementById('css_otherAmountPaymentLabel').classList.remove('wth2_css_radio_selected');
					document.getElementById("otherAmountPaymentInputField").value ='';
					document.getElementById('css_otherAmountPayment').checked=false;
				}
				if(document.getElementById('css_remainingBalancePayment')){
					document.getElementById('css_remainingBalancePayment').checked=true;
				}
			
			}, 500);
			
			dispatch(paymentOtherActiveFalse());						
			if(css_ins === 'Y'){
				if(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.hasOwnProperty("payRemainingBalance")){
					dispatch(paymentAmountUpdater(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payRemainingBalance));
				}
				else{
					if(props.updateBooking.insuranceQuote.makePaymentWithInsurance.hasOwnProperty('priceAmount')){
						dispatch(paymentAmountUpdater(props.updateBooking.insuranceQuote.makePaymentWithInsurance.priceAmount));
					}
				}
			}
			else{
				if(props.updateBooking.makePayment.paymentOptions.hasOwnProperty('payRemainingBalance')){
					dispatch(paymentAmountUpdater(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
				}
			}
		}
     function changeInsuranceChoice(insuranceOption){
			if(insuranceOption==='yes'){				
				dispatch(paidInFullLanguageUpdater('Remaining Balance'));
				if (props.updateBooking.makePayment.paymentOptions.payRemainingBalance<25){
					dispatch(paymentAmountUpdater(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.makeMinimumPayment));;
				}
				dispatch(css_insAdd());
				dispatch(includeInsuranceBalanceNoteUpdate('Your Updated Balance with Travel Insurance:'));
				dispatch(message8DisplayPropertyDisplay());
				props.CallTracker("Customer Self Service", "Insurance", "With Insurance");
				document.getElementById('css_insuranceYesLabel').classList.add('wth2_css_radio_selected');
				document.getElementById('css_insuranceYesLabel').classList.remove('wth2_css_radio_notselected');
				document.getElementById('css_insuranceNoLabel').classList.add('wth2_css_radio_notselected');
				document.getElementById('css_insuranceNoLabel').classList.remove('wth2_css_radio_selected');
				document.getElementById('css_yes_insurance').checked=true;
				document.getElementById('css_no_insurance').checked=false;
				dispatch(totalcostset(parseFloat(props.updateBooking.bookingSummary.charges.totalCost) + parseFloat(props.updateBooking.insuranceQuote.priceAmount)));
				dispatch(insuranceStatusPaymentRequired());
				dispatch(remainingBalanceSet(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payBalanceExcludeFuturePayments));

				dispatch(remainingBalanceAsFloatSet(parseFloat(remainingBalance)));
				if(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.hasOwnProperty("makeMinimumPayment")){
					dispatch(minimumPaymentAmountValue(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.makeMinimumPayment));
				}
				else{
					dispatch(minimumPaymentAmountValue(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payRemainingBalance));
				}
				dispatch(balancePayRemainingValue(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payRemainingBalance));
				dispatch(payRemainingBalanceValue(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payRemainingBalance));
				
				if(payRemainingBalance===props.updateBooking.insuranceQuote.priceAmount){
					changePaymentChoiceFull();
					dispatch(paymentAmountUpdater(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payBalanceIncludeFuturePayments));
					
				}
				else{
					if (paymentOption === "Full"){
						changePaymentChoiceFull();
						dispatch(paymentAmountUpdater(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payRemainingBalance));
					}
					else if (paymentOption === 'Other') {
						changePaymentChoiceOther();
						dispatch(paymentAmountUpdater(0));
						document.getElementById('otherAmountPaymentInputField').value='';
						dispatch(paymentOtherUpdate(""));
					}
				}
			}
			else{
				dispatch(css_insRemove());
				if(props.updateBooking.makePayment.paymentOptions.payRemainingBalance<25 && css_ins==='Y') {
					dispatch(paymentOptionClear());
				}
				if(props.updateBooking.bookingSummary.charges.remainingBalance===0){
					dispatch(paidInFullLanguageUpdater('Paid in Full'));
				}
				else if (props.updateBooking.makePayment.paymentOptions.payRemainingBalance<25){
					dispatch(paymentAmountUpdater(0));
				}
				dispatch(includeInsuranceBalanceNoteUpdate('Your Updated Balance without Travel Insurance:'));
				dispatch(message8DisplayPropertyHide());
				props.CallTracker("Customer Self Service", "Insurance", "Without Insurance");
				document.getElementById('css_insuranceNoLabel').classList.add('wth2_css_radio_selected');
				document.getElementById('css_insuranceNoLabel').classList.remove('wth2_css_radio_notselected');
				document.getElementById('css_insuranceYesLabel').classList.add('wth2_css_radio_notselected');
				document.getElementById('css_insuranceYesLabel').classList.remove('wth2_css_radio_selected');
				document.getElementById('css_no_insurance').checked=true;
				document.getElementById('css_yes_insurance').checked=false;
				dispatch(totalcostset(props.updateBooking.bookingSummary.charges.totalCost));
				dispatch(insuranceStatusNotIncluded());
				dispatch(remainingBalanceSet(props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments));
				dispatch(remainingBalanceAsFloatSet(parseFloat(remainingBalance)));
				if(props.updateBooking.makePayment.paymentOptions.hasOwnProperty('makeMinimumPayment')){
					dispatch(minimumPaymentAmountValue(props.updateBooking.makePayment.paymentOptions.makeMinimumPayment));
				}
				if(props.updateBooking.makePayment.paymentOptions.payRemainingBalance!==null&&props.updateBooking.makePayment.paymentOptions.payRemainingBalance!==''&&typeof(props.updateBooking.makePayment.paymentOptions.payRemainingBalance)!=="undefined"){
					dispatch(payRemainingBalanceValue(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
					dispatch(balancePayRemainingValue(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
				}
				else{
					dispatch(payRemainingBalanceValue(0));
					dispatch(balancePayRemainingValue(0));
				}
				if (paymentOption === "Full"){
					changePaymentChoiceFull();
					if(props.updateBooking.makePayment.paymentOptions.hasOwnProperty('payRemainingBalance')){
						dispatch(paymentAmountUpdater(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
					}
				}
				else if (paymentOption === 'Other') {
					changePaymentChoiceOther();
					dispatch(paymentAmountUpdater(0));
					document.getElementById('otherAmountPaymentInputField').value ='';
					dispatch(paymentOtherUpdate(""));
				}
		
			}
		}
     const Tooltip =
		  <Popup
		    trigger={open => (
				//eslint-disable-next-line
		    		<a href="javascript:void(0);" tabindex="0" id="cvvInfo" className="button wth2-csscvvInfo" aria-label="What is CVV?"><i aria-hidden="true" id="cvvIcon" class="fa fa-info-circle wth2-cvvIcon"></i></a>
		    )}
		    modal
		    nested
		    closeOnDocumentClick
		  >
     		{close => (
    	      <div className="modal wth3-pop cvvModalPopup">
	    	    <div>
			    	<a id="cvvClose" href="# " class="ui-btn ui-corner-all ui-icon-delete ui-btn-icon-notext ui-btn-right ui-link wth3-popClose" role="button" title="Close" onClick={e=> {e.preventDefault();close()}}> </a>
				    
			    	<h5 id="cvvHeaderDescriptor" class="wth3-popuphead">How do I find my CVV number?</h5>
			    	<div class="wth2-cvvPopUpContainer">
			    		<h5 id="cvvHeader" class="wth2-simplePopupHeader">Visa, Mastercard,<br />Discover (3 digits)</h5>
					    <p id="cvvContent" class="wth2-simplePopupContent wth2-popupDatesContent">
					    	<img src="/images_unique/css/Visa-MC-Disc.png" id="cc_cvvPopUpImageVisa" class="wth2-css_cvvPopUpImage" alt="3-digit CVV on back of card" aria-describedby='cvvHeader'/>       
					    </p>
					 </div>
					 <div class="wth2-cvvPopUpContainer">
					    <h5 id="cvvHeader2" class="wth2-simplePopupHeader">American Express<br />(4 digits)</h5>	
				    	<p id="cvvContent2" class="wth2-simplePopupContent wth2-popupDatesContent">
				    		<img src="/images_unique/css/AmEx.png" id="cc_cvvPopUpImageAmex" class="wth2-css_cvvPopUpImage" alt="4-digit CVV on back of card" aria-describedby='cvvHeader2'/>
				    	</p>
					  </div>					
				</div>
    	        
    	      </div>
    	    )}
    	  </Popup>;
    	  const Tooltip2 =
    		  <Popup
    		    trigger={open => (
					//eslint-disable-next-line
    		    		<a href="javascript:void(0);" tabindex="0" id="termsandconditions" className="wth2-css_viewTerms">View Terms &amp; Conditions</a>
    		    )}
    		    modal
    		    nested
    		    closeOnDocumentClick
    		  >
         		{close => (
        	      <div className="modal termsAndConditionsModal">	        	     
	        	      <a id="termsandconditionsClose" href="# " class="ui-btn ui-corner-all ui-icon-delete ui-btn-icon-notext ui-btn-right wth3-popClose" role="button" title="Close" onClick={e=>{e.preventDefault();close();}}> </a>
	        	      <h5 id="termsandconditionsHeader" class="wth2-simplePopupHeader">Terms &amp; conditions</h5>
	        	      <p id="termsandconditionsContent" class="wth2-simplePopupContent wth2-popupDatesContent">Your reservation is subject to cancellation fees and change fees as indicated at time of booking. Subsequent payments to this reservation are pending, based on credit approval. We will contact you only in the event that your payment is not approved. Travel insurance is available to U.S. and Canadian residents only, and may be added to your reservation prior to travel start date up until 10 days after final payment is received. Travel insurance is non-refundable and can only be purchased for all travelers on the reservation.</p>
	        	  </div>
        	    )}
        	  </Popup>;
        	  const Tooltip3 =
        		  <Popup
        		    trigger={open => (
						//eslint-disable-next-line
        		    	<a href="javascript:void(0);" tabindex="0" className="wth2-css_viewTerms visuallyhidden" id="openInsurancePop">ins</a>
        		    )}
        		    modal
        		    nested
        		    closeOnDocumentClick
        		  >
             		{close => (
            	      <div className="modal insuranceModal">	        	     
    	        	      <a id="insuranceClose" href="# " class="ui-btn ui-corner-all ui-icon-delete ui-btn-icon-notext ui-btn-right wth3-popClose" role="button" title="Close" onClick={e=>{e.preventDefault();close()}}> </a> 
    	        	      <h5 id="insuranceAlertHeader" class="wth2-simplePopupHeader">Finish Adding LeisureCare Travel Insurance?</h5>
    	        	      <p id="insuranceAlertContent" class="wth2-simplePopupContent wth2-popupDatesContent">
	    	      	    	<div class="wth2-warningMessage"><div class="wth2-warningMessageHeader"><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Please make a {bookingPastDue===false && <span>minimum</span>} payment of {bookingPastDue===true && <span><NumberFormat value={remainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>}{bookingPastDue===false && <span><NumberFormat value={minimumPaymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>} to add LeisureCare Travel Insurance to your booking now.</div>
	    	      	    	</div>		
			    	      		<div class="wth_css_popButtons"><button id="cssNoThanksButton" class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini" onClick={() => { props.onChangeView('summary-swapInsurance', props.booking, '')} } >No Thanks</button><button id="cssMakePaymentNowButton" class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-ui-btn" onClick={close}>Make Payment Now</button></div>	
		    	      	    </p>
    	        	  </div>
            	    )}
            	  </Popup>;
            	  function checkInsurance(){
					if (props.getSitePropertyValue('BCSS_HOME_REDESIGN') === 'Y') {
						if(css_ins==='Y'){
							document.getElementById("openInsurancePop").click();
						}
						else{
							props.onChangeView('new-summary', props.booking, '');
						}
					} else {
						if(css_ins==='Y'){
							document.getElementById("openInsurancePop").click();
						}
						else{
							props.onChangeView('summary-swap', props.booking, '');
						}
					}
            	  }

        	  //START CREDIT CARD VALIDATION SHARED SCRIPT
        	  function isVisa(cc)
        	  {
        	    if (((cc.length === 16) || (cc.length === 13)) &&
        	        (cc.substring(0,1) === '4'))
        	    return true;
        	  }  

        	  function isMasterCard(cc)
        	  {
        	    let firstdig = cc.substring(0,1);
        	    let seconddig = cc.substring(1,2);
        	    if (((cc.length == 16) && (firstdig == 5) &&
        	        (seconddig >= 1) && (seconddig <= 5))
        	        ||((cc.length == 16) && (firstdig == 2) &&
        	        (seconddig >= 2) && (seconddig <= 7)))
        	    return true;

        	  }

        	  function isAmericanExpress(cc)
        	  {
        	    let firstdig = cc.substring(0,1);
        	    let seconddig = cc.substring(1,2);
        	    if (((cc.length === 15) && (firstdig === '3')) &&
        	        ((seconddig === '4') || (seconddig === '7')))
        	    return true;

        	  } 


        	  function isDiscover(cc)
        	  {
        	  	let first4digs = cc.substring(0,4);
        	  	let first3digs = cc.substring(0,3);
        	  	let first2digs = cc.substring(0,2);
        	  	  if (((cc.length === 16) && (first4digs === "6011"))
        	  			||((cc.length === 16) && (first3digs === "644"))
        	  			||((cc.length === 16) && (first2digs === "65")))
        	  	  return true;
        	  } 

        	  function isAnyCard(cc)
        	  {
        	    if (!isMasterCard(cc) && !isVisa(cc) && !isAmericanExpress(cc) &&
        	        !isDiscover(cc)) {
        	      return false;
        	    }
        	    return true;

        	  }        
        	  
        	  //END CREDIT CARD VALIDATION SHARED SCRIPT
        	  
      function isExpDateFail(month, year){
    	  let today = new Date();
		  let expDate = new Date(year, month, 0, 23, 59, 59);
		if (today>expDate) {
			//fail
			return true;
		}
		else {
			return false;
		}
    	  
      }
      function isExpDateWithin5Days(month, year){
    	let today2 = new Date();
    	let lastDayOfMonth = new Date(today2.getFullYear(), today2.getMonth()+1, 0);	
		let differencelastday = lastDayOfMonth.getDate() - today2.getDate();
		if(month-1 === today2.getMonth() && year === today2.getFullYear()){
			if(differencelastday <=5) {
				//fail
				return true
			}
			else {
			return false;
			}    
		}
    	  
      }
	  function isInsuranceChoiceValid() {
	  	let insuranceChoiceValidState = false;
	  	if(props.updateBooking.bookingSummary.quoteInsuranceInd==='Y' && props.updateBooking.insuranceQuote.priceAmount!==''){
	  		if(document.getElementById("css_yes_insurance").checked===true||document.getElementById("css_no_insurance").checked===true){
	  			document.getElementById("css_paymentErrorMessage_selectInsurance").style.display='none';
	  			document.getElementById("css_insuranceChoice").classList.remove("has-error-radio");
	  			insuranceChoiceValidState = true;
	  		}
	  		else{
	  			document.getElementById("css_paymentFormError").style.display='block';
	  			document.getElementById("css_paymentErrorMessage_selectInsurance").style.display='block';
	  			document.getElementById("css_insuranceChoice").classList.add("has-error-radio");
	  			document.getElementById("css_title_visible").scrollIntoView();
	  			props.CallTracker("Customer Self Service", "Errors", "Select an option for Travel Insurance");
	  			insuranceChoiceValidState = false;
	  		}
	  	}
	  	else{
	  		insuranceChoiceValidState = true;
	  	}
	  	
	  	return insuranceChoiceValidState;
	  }

	  
	  function isPaymentAmountValid() {
	  	let paymentAmountValidState = false;
	  	if(document.getElementById("css_otherAmountPayment")){
		  	if(document.getElementById("css_otherAmountPayment").checked===true){
		  		let otherAmountValueEntered=document.getElementById("otherAmountPaymentInputField").value.trim();
		  		let otherAmountRegex=/^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$/   			
		  		if(otherAmountValueEntered === null || otherAmountValueEntered === ''||otherAmountValueEntered.length<2||!otherAmountRegex.test(otherAmountValueEntered)){
		  			document.getElementById("css_paymentFormError").style.display='block';
		  			document.getElementById("css_paymentErrorMessage_validPaymentAmount").style.display='block';
		  			document.getElementById("otherAmountPaymentInputField").classList.add("has-error");
		  			document.getElementById("css_paymentErrorMessage_validPaymentAmountTooMuch").style.display='none';
		  			document.getElementById("css_paymentErrorMessage_validPaymentAmountTooLittle").style.display='none';
		  			document.getElementById("css_title_visible").scrollIntoView();
		  			props.CallTracker("Customer Self Service", "Errors", "Enter valid payment amount");
		  			paymentAmountValidState=false;
		  		}
		  		else if(otherAmountValueEntered > payRemainingBalance){
		  			document.getElementById("css_paymentFormError").style.display='block';
		  			document.getElementById("css_paymentErrorMessage_validPaymentAmountTooMuch").style.display='block';
		  			document.getElementById("otherAmountPaymentInputField").classList.add("has-error");
		  			document.getElementById("css_paymentErrorMessage_validPaymentAmount").style.display='none';
		  			document.getElementById("css_paymentErrorMessage_validPaymentAmountTooLittle").style.display='none';
		  			document.getElementById("css_title_visible").scrollIntoView();
		  			props.CallTracker("Customer Self Service", "Errors", "Enter payment amount equal to or less than" + <NumberFormat value={payRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />);
		  			paymentAmountValidState=false;
		  		}
		  		else if(otherAmountValueEntered < minimumPaymentAmount){
		  			document.getElementById("css_paymentFormError").style.display='block';
		  			document.getElementById("css_paymentErrorMessage_validPaymentAmountTooLittle").style.display='block';
		  			document.getElementById("otherAmountPaymentInputField").classList.add("has-error");
		  			document.getElementById("css_paymentErrorMessage_validPaymentAmount").style.display='none';
		  			document.getElementById("css_paymentErrorMessage_validPaymentAmountTooMuch").style.display='none';
		  			document.getElementById("css_title_visible").scrollIntoView();
		  			props.CallTracker("Customer Self Service", "Errors", "Enter payment amount $25.00 or greater");
		  			paymentAmountValidState=false;
		  		}
		  		else{
		  			if(document.getElementById("css_paymentErrorMessage_validPaymentAmount")){
				  		document.getElementById("css_paymentErrorMessage_validPaymentAmount").style.display='none';
				  		document.getElementById("css_paymentErrorMessage_validPaymentAmountTooMuch").style.display='none';
				  		document.getElementById("css_paymentErrorMessage_validPaymentAmountTooLittle").style.display='none';
			  		}
			  		if(document.getElementById("otherAmountPaymentInputField")){
			  			document.getElementById("otherAmountPaymentInputField").classList.remove("has-error");
			  		}
			  		paymentAmountValidState=true;
		  			
		  		}
		  		
		  	}
		  	else{
		  		if(document.getElementById("css_paymentErrorMessage_validPaymentAmount")){
			  		document.getElementById("css_paymentErrorMessage_validPaymentAmount").style.display='none';
			  		document.getElementById("css_paymentErrorMessage_validPaymentAmountTooMuch").style.display='none';
			  		document.getElementById("css_paymentErrorMessage_validPaymentAmountTooLittle").style.display='none';
		  		}
		  		if(document.getElementById("otherAmountPaymentInputField")){
		  			document.getElementById("otherAmountPaymentInputField").classList.remove("has-error");
		  		}
		  		paymentAmountValidState=true;
		  	}
	  	}
	  	else{
	  		if(document.getElementById("css_paymentErrorMessage_validPaymentAmount")){
		  		document.getElementById("css_paymentErrorMessage_validPaymentAmount").style.display='none';
		  		document.getElementById("css_paymentErrorMessage_validPaymentAmountTooMuch").style.display='none';
		  		document.getElementById("css_paymentErrorMessage_validPaymentAmountTooLittle").style.display='none';
	  		}
	  		if(document.getElementById("otherAmountPaymentInputField")){
	  			document.getElementById("otherAmountPaymentInputField").classList.remove("has-error");
	  		}
	  		paymentAmountValidState=true;
	  	}
	  	
	  	return paymentAmountValidState;
	  }

	  function isAddress1Valid() {
	  	let address1ValidState = false;
	  	if(showBillingAddressFields){
	  		let address1Value = document.getElementById("css_address1").value;
	  		let address1RegEx = /^[ A-Za-z0-9.#'-]*$/;
	  		if(address1Value===null||address1Value===''||address1Value.length>30||address1Value.length<2||!address1RegEx.test(address1Value)){	  			
	  			document.getElementById("css_paymentFormError").style.display='block';
	  			document.getElementById("css_paymentErrorMessage_validStreetAddress1").style.display='block';
	  			document.getElementById("css_address1Container").classList.add("has-error");
	  			document.getElementById("css_title_visible").scrollIntoView();
	  			props.CallTracker("Customer Self Service", "Errors", "Enter valid street address 1");
	  			address1ValidState=false;	  			
	  		}
	  		else{
	  			document.getElementById("css_paymentErrorMessage_validStreetAddress1").style.display='none';
	  			document.getElementById("css_address1Container").classList.remove("has-error");
	  			address1ValidState=true;
	  		}	  		
	  	}
	  	else{
	  		if(document.getElementById("css_paymentErrorMessage_validStreetAddress1")){	  	
		  		document.getElementById("css_paymentErrorMessage_validStreetAddress1").style.display='none';
	  		}
	  		if(document.getElementById("css_address1Container")){
	  			document.getElementById("css_address1Container").classList.remove("has-error");
	  		}
		  		address1ValidState=true;
	  		
	  	}
	  	
	  	return address1ValidState;
	  }
	  
	  function isAddress2Valid(){
		  let address2ValidState = true;
		  if(document.getElementById("css_address2")){
			  let address2Value = document.getElementById("css_address2").value;
			  	if(showBillingAddressFields & address2Value !==null && address2Value !== ''){	
			  		let address2RegEx = /^[ A-Za-z0-9.#'-]*$/;
			  		if(address2Value.length>30||address2Value.length<2||!address2RegEx.test(address2Value)){	  			
			  			document.getElementById("css_paymentFormError").style.display='block';
			  			document.getElementById("css_paymentErrorMessage_validStreetAddress2").style.display='block';
			  			document.getElementById("css_address2Container").classList.add("has-error");
			  			document.getElementById("css_title_visible").scrollIntoView();
			  			props.CallTracker("Customer Self Service", "Errors", "Enter valid street address 2");
			  			address2ValidState=false;	  			
			  		}
			  		else{	  			
			  			document.getElementById("css_paymentErrorMessage_validStreetAddress2").style.display='none';
			  			document.getElementById("css_address2Container").classList.remove("has-error");
			  			address2ValidState=true;
			  		}	  		
			  	}
			  	else{
			  		if(document.getElementById("css_paymentErrorMessage_validStreetAddress2")){	  	
				  		document.getElementById("css_paymentErrorMessage_validStreetAddress2").style.display='none';
			  		}
			  		if(document.getElementById("css_address2Container")){
			  			document.getElementById("css_address2Container").classList.remove("has-error");
			  		}
				  		address2ValidState=true;
			  		
			  	}
	  		}
		  return address2ValidState;
	  }

	  function isCityValid() {
	  	let cityValidState = false;
	  	if(showBillingAddressFields){
	  		let cityValue = document.getElementById("css_city").value;
	  		let cityRegEx = /^[ A-Za-z0-9.#'-]*$/;
	  		if(cityValue===null||cityValue===''||cityValue.length>30||cityValue.length<2||!cityRegEx.test(cityValue)){	  			
	  			document.getElementById("css_paymentFormError").style.display='block';
	  			document.getElementById("css_paymentErrorMessage_validCity").style.display='block';
	  			document.getElementById("css_cityContainer").classList.add("has-error");
	  			document.getElementById("css_title_visible").scrollIntoView();
	  			props.CallTracker("Customer Self Service", "Errors", "Enter valid city");
	  			cityValidState=false;	  			
	  		}
	  		else{	  			
	  			document.getElementById("css_paymentErrorMessage_validCity").style.display='none';
	  			document.getElementById("css_cityContainer").classList.remove("has-error");
	  			cityValidState=true;
	  		}	  		
	  	}
	  	else{
	  		if(document.getElementById("css_paymentErrorMessage_validCity")){	  	
		  		document.getElementById("css_paymentErrorMessage_validCity").style.display='none';
	  		}
	  		if(document.getElementById("css_cityContainer")){
	  			document.getElementById("css_cityContainer").classList.remove("has-error");
	  		}
		  		cityValidState=true;
	  		
	  	}
	  	return cityValidState;
	  }

	  function isStateValid() {
	  	let stateValidState = false;
	  	if(showBillingAddressFields){
	  		let selectedStateValue = document.getElementById("css_paymentState").value;
	  		if(selectedStateValue!==null && selectedStateValue!==''){
	  			document.getElementById("css_paymentErrorMessage_selectState").style.display='none';
	  			document.getElementById("css_stateContainer").classList.remove("has-error");
	  			stateValidState = true;
	  		}
	  		else{
	  			document.getElementById("css_paymentFormError").style.display='block';
	  			document.getElementById("css_paymentErrorMessage_selectState").style.display='block';
	  			document.getElementById("css_stateContainer").classList.add("has-error");
	  			document.getElementById("css_title_visible").scrollIntoView();
	  			props.CallTracker("Customer Self Service", "Errors", "Select state");
	  			stateValidState = false;	  		
	  		}
	  	}
	  	else{
	  		document.getElementById("css_paymentErrorMessage_selectState").style.display='none';
  			if(document.getElementById("css_stateContainer")){
  				document.getElementById("css_stateContainer").classList.remove("has-error");
  			}
  			stateValidState = true;
	  		
	  	}
	  	
	  	return stateValidState;
	  }

	  function isZipValid() {
	  	let zipValidState = false;
	  	if(showBillingAddressFields){
	  		let zipValue = document.getElementById("css_zip").value;
	  		let zipRegEx = /^[0-9]{5}$/;
	  		if(zipValue===null||zipValue===''||zipValue.length>30||zipValue.length<2||!zipRegEx.test(zipValue)){	  			
	  			document.getElementById("css_paymentFormError").style.display='block';
	  			document.getElementById("css_paymentErrorMessage_validZip").style.display='block';
	  			document.getElementById("css_zipContainer").classList.add("has-error");
	  			document.getElementById("css_title_visible").scrollIntoView();
	  			props.CallTracker("Customer Self Service", "Errors", "Enter valid zip code");
	  			zipValidState=false;	  			
	  		}
	  		else{	  			
	  			document.getElementById("css_paymentErrorMessage_validZip").style.display='none';
	  			document.getElementById("css_zipContainer").classList.remove("has-error");
	  			zipValidState=true;
	  		}	  		
	  	}
	  	else{
	  		if(document.getElementById("css_paymentErrorMessage_validZip")){	  	
		  		document.getElementById("css_paymentErrorMessage_validZip").style.display='none';
	  		}
	  		if(document.getElementById("css_zipContainer")){
	  			document.getElementById("css_zipContainer").classList.remove("has-error");
	  	
	  		}
		  		zipValidState=true;
	  		
	  	}
	  	return zipValidState;
	  }
	  function isPaymentChoiceValid(){
		  let paymentChoiceValidState = false;
		  let paymentChoiceRemainingValue = document.getElementById("css_remainingBalancePayment").checked;
		  let paymentChoiceOtherValue = false;
		  if(document.getElementById("css_otherAmountPayment")){
			  paymentChoiceOtherValue = document.getElementById("css_otherAmountPayment").checked;
		  }
		  
		  if(document.getElementById("css_otherAmountPayment")){
			  if(paymentChoiceRemainingValue===true || paymentChoiceOtherValue===true){				  
				  document.getElementById("css_paymentErrorMessage_validPaymentChoice").style.display='none';
		  		  document.getElementById("css_paymentChoiceContainer").classList.remove("has-error");
				  paymentChoiceValidState = true;
			  }
			  else{
				  document.getElementById("css_paymentFormError").style.display='block';
				  document.getElementById("css_paymentErrorMessage_validPaymentChoice").style.display='block';
		  		  document.getElementById("css_paymentChoiceContainer").classList.add("has-error");
				  paymentChoiceValidState = false;
			  }
		  }
		  else{
			  if(paymentChoiceRemainingValue===true){
				  	document.getElementById("css_paymentErrorMessage_validPaymentChoice").style.display='none';
		  			document.getElementById("css_paymentChoiceContainer").classList.remove("has-error");
		  			paymentChoiceValidState = true;
			  }
			  else{
				  document.getElementById("css_paymentFormError").style.display='block';
				  document.getElementById("css_paymentErrorMessage_validPaymentChoice").style.display='block';
		  		  document.getElementById("css_paymentChoiceContainer").classList.add("has-error");
				  paymentChoiceValidState = false;
			  }
		  }
		  return paymentChoiceValidState;
		  
	  }
	  function isCreditCardHolderValid() {
	  	let creditCardHolderValidState = false;	  	
	  	let ccHolderValue = document.getElementById("customerNumber").value;
  		if(ccHolderValue!==null && ccHolderValue!==''){
  			document.getElementById("css_paymentErrorMessage_selectCreditCardHolder").style.display='none';
  			document.getElementById("css_ccHolderContainer").classList.remove("has-error");
  			creditCardHolderValidState = true;
  		}
  		else{
  			document.getElementById("css_paymentFormError").style.display='block';
  			document.getElementById("css_paymentErrorMessage_selectCreditCardHolder").style.display='block';
  			document.getElementById("css_ccHolderContainer").classList.add("has-error");
  			document.getElementById("css_title_visible").scrollIntoView();
  			props.CallTracker("Customer Self Service", "Errors", "Select credit card holder");
  			creditCardHolderValidState = false;	  		
  		}
	  	
	  	return creditCardHolderValidState;
	  }

	  function isBillingAddressValid() {
	  	let billingAddressValidState = false;
	  	if(showBillingAddressDrop){
		  	let billingAddressValue = document.getElementById("customerAddressNumber").value;
	  		if(billingAddressValue!==null && billingAddressValue!==''){
	  			document.getElementById("css_paymentErrorMessage_selectBillingAddress").style.display='none';
	  			document.getElementById("css_BillingAddressDrop").classList.remove("has-error");
	  			billingAddressValidState = true;
	  		}
	  		else{
	  			document.getElementById("css_paymentFormError").style.display='block';
	  			document.getElementById("css_paymentErrorMessage_selectBillingAddress").style.display='block';
	  			document.getElementById("css_BillingAddressDrop").classList.add("has-error");
	  			document.getElementById("css_title_visible").scrollIntoView();
	  			props.CallTracker("Customer Self Service", "Errors", "Select billing address");
	  			billingAddressValidState = false;	  		
	  		}
  		}
	  	
	  	return billingAddressValidState;
	  }

	  function isCcNumberValid() {
	  	let ccNumberValidState = false;
	  	
	  	let ccNumValue = document.getElementById("token").value;
  		if(ccNumValue===null||ccNumValue===''||!isAnyCard(ccNumValue)){	  			
  			document.getElementById("css_paymentFormError").style.display='block';
  			document.getElementById("css_paymentErrorMessage_validcreditcardnumber").style.display='block';
  			document.getElementById("css_ccNumberLine").classList.add("has-error");
  			document.getElementById("css_title_visible").scrollIntoView();
  			props.CallTracker("Customer Self Service", "Errors", "Enter valid credit card number");
  			ccNumberValidState=false;	  			
  		}
  		else{	  			
  			document.getElementById("css_paymentErrorMessage_validcreditcardnumber").style.display='none';
  			document.getElementById("css_ccNumberLine").classList.remove("has-error");
  			ccNumberValidState=true;
  		}	  
	  	
	  	return ccNumberValidState;
	  }

	  function isCcvValid() {
	  	let ccvValidState = false;
	  	let ccvValue = document.getElementById("css_cccvv").value;
  		let ccvRegEx = /^[0-9]{3,4}$/;
  		if(ccvValue===null||ccvValue===''){	  			
  			document.getElementById("css_paymentFormError").style.display='block';
  			document.getElementById("css_paymentErrorMessage_requiredcccvv").style.display='block';
  			document.getElementById("css_ccCVVLine").classList.add("has-error");
  			document.getElementById("css_title_visible").scrollIntoView();
  			props.CallTracker("Customer Self Service", "Errors", "Enter valid CVV number");
  			ccvValidState=false;	  	
  			
  		}
  		else if(!ccvRegEx.test(ccvValue)){	  			
  			document.getElementById("css_paymentFormError").style.display='block';
  			document.getElementById("css_paymentErrorMessage_validcccvv").style.display='block';
  			document.getElementById("css_ccCVVLine").classList.add("has-error");
  			document.getElementById("css_title_visible").scrollIntoView();
  			props.CallTracker("Customer Self Service", "Errors", "Enter CVV number");
  			ccvValidState=false;	  			
  		}
  		else{	  			
  			document.getElementById("css_paymentErrorMessage_requiredcccvv").style.display='none';
  			document.getElementById("css_paymentErrorMessage_validcccvv").style.display='none';
  			document.getElementById("css_ccCVVLine").classList.remove("has-error");
  			ccvValidState=true;
  		}	  	  	
	  	return ccvValidState;
	  }

	  function isExpirationDateValid() {
	  	let expirationDateValidState = false;
	  	let month=document.getElementById("ccMonth").value;
	  	let year=document.getElementById("ccYear").value;
	  	if(month === null || month === "" || year === null || year === "" || isExpDateFail(month,year)===true){
	  		document.getElementById("css_paymentFormError").style.display='block';
  			document.getElementById("css_paymentErrorMessage_selectExpDate").style.display='block';
  			document.getElementById("css_ccExprLine").classList.add("has-error");
  			document.getElementById("css_title_visible").scrollIntoView();
  			props.CallTracker("Customer Self Service", "Errors", "Select expiration year");
  			props.CallTracker("Customer Self Service", "Errors", "Select expiration month");
	  		expirationDateValidState=false;
	  	}
	  	else if(isExpDateWithin5Days(month,year)===true){
	  		document.getElementById("css_paymentFormError").style.display='block';
  			document.getElementById("css_paymentErrorMessage_5dayExpDate").style.display='block';
  			document.getElementById("css_ccExprLine").classList.add("has-error");
  			document.getElementById("css_title_visible").scrollIntoView();
  			props.CallTracker("Customer Self Service", "Errors", "Select expiration year");
  			props.CallTracker("Customer Self Service", "Errors", "Select expiration month");
	  		expirationDateValidState=false;
	  	}
	  	else{
	  		document.getElementById("css_paymentErrorMessage_selectExpDate").style.display='none';
	  		document.getElementById("css_paymentErrorMessage_5dayExpDate").style.display='none';
  			document.getElementById("css_ccExprLine").classList.remove("has-error");
	  		expirationDateValidState=true;
	  	}
		  	
	  	
	  	return expirationDateValidState;
	  }
	  function paymentFormIsValid() {
	  	let paymentFormState = false;
	  	let insuranceChoiceValid = isInsuranceChoiceValid();
	  	let paymentAmountValid = isPaymentAmountValid();
	  	let address1Valid = isAddress1Valid();
	  	let address2Valid = isAddress2Valid();
	  	let cityValid = isCityValid();
	  	let stateValid = isStateValid();
	  	let zipValid = isZipValid();
	  	let creditCardHolderValid = isCreditCardHolderValid();
	  	let billingAddressValid = isBillingAddressValid();
	  	let ccNumberValid = isCcNumberValid();
	  	let ccvValid = isCcvValid();
	  	let expirationDateValid = isExpirationDateValid();
	  	let paymentChoiceValid = isPaymentChoiceValid();
	  	
	  	paymentFormState = insuranceChoiceValid && paymentAmountValid && address1Valid && address2Valid && cityValid && stateValid && zipValid && creditCardHolderValid && billingAddressValid && ccNumberValid && ccvValid && expirationDateValid && paymentChoiceValid;
	  	return paymentFormState;
	  	
	  }
	  function getCookie(cname){
    	  let name = cname + "=";
    	  let decodedCookie = decodeURIComponent(document.cookie);
    	  let ca = decodedCookie.split(';');
    	  for(let i = 0; i <ca.length; i++) {
    	    let c = ca[i];
    	    while (c.charAt(0) === ' ') {
    	      c = c.substring(1);
    	    }
    	    if (c.indexOf(name) === 0) {
    	      return c.substring(name.length, c.length);
    	    }
    	  }
    	  return "";
    	}
    

	  function paymentFormValidationSubmit() {
		  if(paymentFormIsValid()){	
			  document.getElementById("css_paymentFormError").style.display='none';
			if(showBillingAddressFields){
			  dispatch(cssAddress1Update(document.getElementById("css_address1").value));
			  dispatch(cssAddress2Update(document.getElementById("css_address2").value));
			  dispatch(cssCityUpdate(document.getElementById("css_city").value));
			  dispatch(cssPaymentStateUpdate(document.getElementById("css_paymentState").value));
			  dispatch(cssZipUpdate(document.getElementById("css_zip").value));
			}
			  dispatch(ccMonthUpdate(document.getElementById("ccMonth").value));
			  dispatch(ccYearUpdate(document.getElementById("ccYear").value));
			  console.debug('Validate payment...');	
			  
			  let quotedInsuranceAvailable = 0;			  
			  if(!props.updateBooking.hasOwnProperty('insuranceQuote')){
				  quotedInsuranceAvailable = 0;
				}
				else{
					quotedInsuranceAvailable = props.updateBooking.insuranceQuote.priceAmount;
				}
			  if(css_ins==='N'||(quotedInsuranceAvailable===0||quotedInsuranceAvailable===''||quotedInsuranceAvailable===null))
				{
				  quotedInsuranceAvailable = 0;
				}
				let validate_todaysPayment = paymentAmount - quotedInsuranceAvailable;
				let url = '/wthrest/customer-self-service/confirmPayment.rs';
			    let payload = {
			        "bookingNumber": props.updateBooking.bookingNumber,
			        "paymentAmount" : validate_todaysPayment,
			        "sessionId" : getCookie("WDVID")
			    };
			    ajaxSpinnerShow();
			    fetch(url, {
			        method: 'POST',
			        headers: {
			            'Accept': 'application/json',
			            'Content-Type': 'application/json'
			        },
			        body: JSON.stringify(payload)
			    }).then(jsonPaymentConfirmResponse => jsonPaymentConfirmResponse.json()).then(jsonPaymentConfirmResponse => {
			    	if(jsonPaymentConfirmResponse===''||jsonPaymentConfirmResponse===null) {
			    		ajaxSpinnerHide();
			    		dispatch(message6DisplayPropertyDisplay());

			        } else {  
			        	dispatch(message6DisplayPropertyHide());
			        	dispatch(confirmViewUpdate(jsonPaymentConfirmResponse));
			        	dispatch(confirmViewFuturePaymentsUpdate(jsonPaymentConfirmResponse.futurePayments));
			        	dispatch(confirmViewRemainingBalanceUpdate(jsonPaymentConfirmResponse.remainingBalance));
			        	if(jsonPaymentConfirmResponse.futurePayments!==null && jsonPaymentConfirmResponse.futurePayments!==''){			        		
							//success			        		
			        		localStorage.setItem("scheduledPaymentHasChanged", false);
			        		Object.keys(jsonPaymentConfirmResponse.futurePayments).forEach(function(key){
			        			let parsedCurrentAmount = Number(jsonPaymentConfirmResponse.futurePayments[key].currentAmount);
			        			let parsedNewAmount = Number(jsonPaymentConfirmResponse.futurePayments[key].newAmount);			        			
			        			if(parsedCurrentAmount > parsedNewAmount) {							
									dispatch(scheduledPaymentHasChangedTrue());
									localStorage.setItem("scheduledPaymentHasChanged", true);									
								}	
								
			        		});

						}
			        	
			        	if(scheduledPaymentHasChanged === true){
							props.CallTracker("Customer Self Service", "Page Alert", "Please Note: Your payment will reduce a previously scheduled payment, as reflected in the New Summary of Charges above.");
						}
			        	//open popup
			        	ajaxSpinnerHide();
			        	props.CallTracker("Customer Self Service", "OpenPopup", "Payment Confirmation Overlay");
		  			  	document.getElementById("openValidatePaymentPop").click();
						
						const upliftEl = document.getElementById('up-pay-monthly-payment');
						const monthlyPayment = upliftEl ? upliftEl.checked : false;

						if(document.querySelector("#popup-root") && !monthlyPayment){
							document.getElementsByTagName('body')[0].style = 'overflow-y: hidden';	
							document.querySelector("#css_confirmPaymentButton").scrollIntoView();
							setTimeout(function(){
								const observer = new MutationObserver(function(mutations_list) {
									mutations_list.forEach(function(mutation) {
										mutation.removedNodes.forEach(function(removed_node) {
											document.getElementsByTagName('body')[0].style = 'overflow-y: auto';	
											observer.disconnect();
											
										});
									});
								});

								observer.observe(document.querySelector("#popup-root"), { subtree: false, childList: true });				  			
							
							}, 2000); 
						}
		  			  
		  			  
			  			
			        }
					
			    }).catch(error => {
			    	ajaxSpinnerHide();
			    	dispatch(message6DisplayPropertyDisplay());
			    });       
				

			}
		}

	  	function closeVerificationPopup(){
	  		document.getElementById("closeValidatePaymentPop").click();
	  	}
		function paymentFormSubmit() {

			//document.querySelector("#css_paymentFormError").style.display="none";
			console.debug('Submit payment...');
			
			const upliftEl = document.getElementById('up-pay-monthly-payment');
			const monthlyPayment = upliftEl ? upliftEl.checked : false;
			
			let url = '/wthrest/customer-self-service/makePayment.rs';
		    let payload = {
		        "bookingNumber": props.updateBooking.bookingNumber,
		        "css_ins" : css_ins,
		        "paymentOption" : paymentOption,
		        "paymentOther" : paymentOther,
		        "customerNumber" :  document.getElementById("customerNumber").value,
		        "otherFirstName" : '',
		        "otherMI" : '',
		        "otherLastName" : '',
		        "token" : document.getElementById("token").value,
		        "ccMonth" : ccMonth,
		        "ccYear" : ccYear,
		        "customerAddressNumber" : document.getElementById("customerAddressNumber").value,
		        "css_address1" : css_address1,
		        "css_address2" : css_address2,
		        "css_city" : css_city,
		        "css_paymentState" : css_paymentState,
		        "css_zip" : css_zip,
		        "paymentAmount" : paymentAmount,
		        "cvv" : document.getElementById("css_cccvv").value,
		        "sessionId" : getCookie("WDVID"),
				"monthlyPayment" : monthlyPayment
		    };
		    ajaxSpinnerShow();
		    fetch(url, {
		        method: 'POST',
		        headers: {
		            'Accept': 'application/json',
		            'Content-Type': 'application/json'
		        },
		        body: JSON.stringify(payload)
		    }).then(jsonPaymentSubmitResponse => jsonPaymentSubmitResponse.json()).then(jsonPaymentSubmitResponse => {
		    	if(jsonPaymentSubmitResponse===''||jsonPaymentSubmitResponse===null) {
		    		ajaxSpinnerHide();
		    		document.getElementById("closeValidatePaymentPop").click();
		            dispatch(message6DisplayPropertyDisplay());
		        } else { 
					//success
	        		dispatch(message6DisplayPropertyHide());
	        		props.CallTracker("Customer Self Service", "Submit Payment", "Payment Confirmation Overlay");
	    			props.CallTracker("Customer Self Service", "Payment Amount", paymentOption);
	    			if (css_ins === 'Y'){
	    				props.CallTracker("Customer Self Service", "Insurance Purchase", "Post Booking");
	    			}
	    			ajaxSpinnerHide();
	    			props.onChangeViewConfirm(props.booking, jsonPaymentSubmitResponse);
					
		        }
		    }).catch(error => {
		    	ajaxSpinnerHide();
		    	document.getElementById("closeValidatePaymentPop").click();
		    	dispatch(message6DisplayPropertyDisplay());
		    	props.CallTracker("Customer Self Service", "Errors", "Payment Submission Failed");
		    });       
		}
		const ControlledRefPopup = () => {
			window.dataLayer = window.dataLayer || [];	        
			  const ref = useRef();
			  const openTooltip = () => ref.current.open();
			  const closeTooltip = () => {ref.current.close();document.getElementsByTagName('body')[0].style = 'overflow-y: auto';}
			  const toggleTooltip = () => ref.current.toggle();
			  return (
			    <div>
			      <button type="button" className="button visuallyhidden" id="openValidatePaymentPop" onClick={openTooltip}>
			        open
			      </button>
			      <button type="button" className="button visuallyhidden" id="closeValidatePaymentPop" onClick={closeTooltip}>
			        close
			      </button>

			      <button type="button" className="button visuallyhidden" onClick={toggleTooltip}>
			        toggle
			      </button>
			      <Popup
			        ref={ref}
			        trigger={
			          <button type="button" className="button visuallyhidden">
			            I am the trigger
			          </button>
			        } modal
			      >
			        <div className="paymentVerificationModal">
			        <div id="paymentVerification">
			    	<div id="paymentVerificationPopup" tabindex="-1" aria-hidden="true" aria-labelledby="paymentVerificationHeader" >
			    	   	<a id="paymentVerificationClose" href="# " class="ui-btn ui-corner-all ui-icon-delete ui-btn-icon-notext ui-btn-right wth2-popupCloseFunction" role="button" onClick={e =>{e.preventDefault();closeVerificationPopup()}} title="Close"> </a> 
			    	    <h5 id="paymentVerificationHeader" class="wth2-simplePopupHeader wth2_css_paymentVerificationHeader">Payment Confirmation</h5>
			    	    <div id="css_paymentVerificationDescription" class="wth2-paymentVerificationDescription">Please review your Summary of Charges and confirm today&#39;s payment below.</div>
			    	    <p id="paymentVerificationContent" class="wth2-simplePopupContent wth2-popupDatesContent">	
			    		<form name="css_paymentVerification" id="css_paymentVerification" novalidate>			
			    			<div class="wth2-paymentVerificationSOC">
			    				<div class="wth2-paymentVerificationLine3 wth2-bold wth2-css_paymentVerificationSOCNewHeader" id="css_paymentVerificationSOCNewHeader">Summary of Charges</div>
			    	    		<div class="wth2-paymentVerificationLine wth2-bold" id="css_paymentVerification_SOCTotal">Total</div><div class="wth2-paymentVerificationLine2" id="css_paymentVerification_SOCTotalContent"><NumberFormat value={totalcost} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></div>
			    	    		<div class="wth2-paymentVerificationLine wth2-bold" id="css_paymentVerification_SOCInsurancel">Travel Insurance</div><div class="wth2-paymentVerificationLine2" id="css_paymentVerification_SOCInsuranceContent">
			    	    			{css_ins==='Y' &&
			    	    				<span>Payment Required</span>
									}
			    	    			{(css_ins==='N' || css_ins==='' || css_ins===null) &&
			    	    			<span>{insuranceStatus}</span>
									}
			    	    		</div>
			    	    		{css_ins==='Y' &&
			    	    			<div class="wth2-paymentVerificationLine4 wth2-paymentVerification_insAddition" >Adding LeisureCare for <NumberFormat value={props.updateBooking.insuranceQuote.priceAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></div>
			    	    		}
			    	    		<div class="wth2-paymentVerificationLine wth2-bold" id="css_paymentVerification_SOCTotalPrevious">Previous Payments</div>
			    	    		{props.updateBooking.bookingSummary.charges.paymentsToDate!==0 &&
			    	    			<div class="wth2-paymentVerificationLine2" id="css_paymentVerification_SOCPreviousContent">- <NumberFormat value={props.updateBooking.bookingSummary.charges.paymentsToDate} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></div>
			    	    		}
			    	    		{props.updateBooking.bookingSummary.charges.paymentsToDate===0 &&
			    	    		<div class="wth2-paymentVerificationLine2" id="css_paymentVerification_SOCPreviousContent">$0.00</div>
			    	    		}
			    	    		<div class="wth2-paymentVerificationLine wth2-bold" id="css_paymentVerification_SOCTotalNew">Today&#39;s Payment</div><div class="wth2-paymentVerificationLine2" id="css_paymentVerification_SOCNewContent">- <NumberFormat value={paymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></div>
			    	    		<div class="wth2-paymentVerificationLine wth2-bold wth2-paymentVerificationRemBalLine" id="css_paymentVerification_SOCTotalRemaining">Remaining Balance</div>
			    	    		<div class="wth2-paymentVerificationLine2 wth2-paymentVerificationRemBalLine" id="css_paymentVerification_SOCRemainingContent">
			    	    			{confirmViewRemainingBalance===0 &&
			    	    			<span>Paid in Full</span>
			    	    			}
			    	    			{confirmViewRemainingBalance>0 &&
			    	    			<span><NumberFormat value={confirmViewRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
			    	    			}
			    	    		</div>
			    	    		{//eslint-disable-next-line
									confirmViewFuturePayments!=null && confirmViewFuturePayments!='' &&
			    	    		<div class="wth2-paymentVerificationLine3 wth2-bold" id="css_paymentVerification_SOCTotalScheduled">Scheduled Payments</div>
			    	    		}
			    	    		{confirmViewFuturePayments!==null && confirmViewFuturePayments!=='' &&
			    	    		<div class="wth2-paymentVerificationLine3 wth2-paymentVerification_FPcontainer" id="css_paymentVerification_SOCTotalScheduledContent">
			    	    			{confirmViewFuturePayments.map((newfuturepayments, index, arr)=>(
			    	    				<div id={"css_newFuturePay_" + index + "_line"}>
			    							{parseFloat(newfuturepayments.currentAmount) > parseFloat(newfuturepayments.newAmount) &&
			    							<div>
			    								<span id={"css_newFuturePay_" + index + "_pricecurrent"} class="wth2-newFuturePay_oldSCPrice"><NumberFormat value={newfuturepayments.currentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span> <span id={"css_newFuturePay_" + index + "_Now"} class="wth2-bold wth2-headerH5">Now <span id={"css_newFuturePay_" + index + "_pricenew"}><NumberFormat value={newfuturepayments.newAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span></span> on <span className="wth3-futurePayCCType" id={"css_newFuturePay_" + index + "_cctype"}>{newfuturepayments.creditCardType.replace("(R)", "\u00AE ").toLowerCase()}</span> ending in <span id={"css_newFuturePay_" + index + "_ccnumber"}>{newfuturepayments.maskedCreditCardNumber.slice(-4)}</span> on {newfuturepayments.withinFiveDays===false &&<span id={"css_newFuturePay_" + index + "_date"}>{newfuturepayments.futurePaymentDate}</span>}{newfuturepayments.withinFiveDays===true && newfuturepayments.newAmount!=='0' && <span id={"css_newFuturePay_" + index + "_date"} class="wth2-css_dateHighlightFP">{newfuturepayments.futurePaymentDate} - Payment will process soon.</span>}				
			    							</div>
			    							}
			    							{parseFloat(newfuturepayments.currentAmount) === parseFloat(newfuturepayments.newAmount) &&
			    							<div>
			    								<span id={"css_newFuturePay_" + index + "_pricecurrent"}><NumberFormat value={newfuturepayments.currentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span> on <span className="wth3-futurePayCCType" id={"css_newFuturePay_" + index + "_cctype"}>{newfuturepayments.creditCardType.replace("(R)", "\u00AE ").toLowerCase()}</span> ending in <span id={"css_newFuturePay_" + index + "_ccnumber"}>{newfuturepayments.maskedCreditCardNumber.slice(-4)}</span> on {newfuturepayments.withinFiveDays===false &&<span id={"css_newFuturePay_" + index + "_date"}>{newfuturepayments.futurePaymentDate}</span>}{newfuturepayments.withinFiveDays===true &&<span class="wth2-css_dateHighlightFP">{newfuturepayments.futurePaymentDate} - Payment will process soon.</span>}				
			    							</div>
			    							}
			    						</div>
			    	    			))}
			    	    			
			    				</div>
			    	    		}
			    	    		{confirmViewFuturePayments!==null && confirmViewFuturePayments!==''&&scheduledPaymentHasChanged===true &&
			    				<div id="scheduledPaymentChangesWiseMessageWraper" class="scheduledPaymentChangesWiseMessageWraper wth2-warningMessage" aria-hidden="true">
			    					<i class="fa fa-exclamation-circle " aria-hidden="true"></i>
			    					<div id="scheduledPaymentChangesWiseMessageHeader" class="wth2-warningMessageHeader">Please Note:</div>
			    					<div id="scheduledPaymentChangesWiseMessageText">Your payment will reduce a previously scheduled payment, as reflected in the New Summary of Charges above.</div>		
			    				</div>
			    	    		}
			    	    	</div>
			    			<div class="wth2-paymentVerificationLine3 wth2-paymentVerification_paymentNewHeader wth2-bold">Today's Payment Information</div>
			    			<div class="wth2-paymentVerification_ccHolderContainer">
			    				<div class="wth2-paymentVerificationLine3 wth2-bold" id="css_paymentVerification_CCHolder">Credit Card Holder:</div>
			    				<div class="wth2-paymentVerificationLine3" id="css_css_paymentVerification_CCHolder_Content">{ccHolderForVerificationName}</div>
			    				{ccBillingAddressForVerification!=='new' && ccBillingAddressForVerification!=='choose' &&
			    				<div class="wth2-paymentVerificationLine3" id="css_css_paymentVerification_Billing_Content">{ccBillingAddressForVerification}</div>
								}
								{ccBillingAddressForVerification==='new' &&
			    				<div class="wth2-paymentVerificationLine3" id="css_css_paymentVerification_Billing_Content">{css_address1} {css_address2} {css_city}, {css_paymentState} {css_zip}</div>
								}
			    			</div>			
			    			<div class="wth2-paymentVerification_ccPaymentContainer">
			    				<div class="wth2-paymentVerificationLine3 wth2-bold" id="css_paymentVerificationPaymentTitle">Payment:</div>
			    				<div class="wth2-paymentVerificationLine3" id="css_paymentVerification_Information"><span id="css_css_paymentVerification_paymentAmountCC"><NumberFormat value={paymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span> will be charged to your credit card **** which expires on <span id="css_css_paymentVerification_ExpDate_Content">{ccMonth}/{ccYear}</span></div>
			    			</div>
			    	    	<div class="wth2-paymentVerificationLine3 wth2-paymentVerification_terms" id="css_paymentVerification_Terms">By submitting this payment, I understand and accept all associated Terms and Conditions. I accept the restrictions and penalties of this fare. I also understand that cancellation fees may apply.</div>
			    			<div class="wth_css_popButtons">
			    				<div id="css_NoPaymentButton" class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini" onClick={() => {closeVerificationPopup()}}>Cancel</div>
			    				<a href="# " id="css_confirmPaymentButton" class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-ui-btn" onClick={e=> {e.preventDefault();paymentFormSubmit()}}>Confirm <NumberFormat value={paymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /> Payment</a>
			    			</div>	
			    	    	
			    	    </form>
			    	    </p>
			    	</div>
			    </div>
			        </div>
			      </Popup>
			    </div>
			  );
			};
			
    return <div>
    {Tooltip3}
    {ControlledRefPopup()}
    <div className="rea-appContainer" id="mainContent" tabindex="-1">
        <div class="wth2-css_heading">
    		<h1 class="wth2-pageTopH1" id="css_title_visible">Make a Payment</h1>
        </div>
        <div class="wth2-css_tripToolsHeading">
        	<div id="css_tripTools">
            	<a class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-ui-btn" href="# " id="css_tripTools_bookingSummary" onClick={e => {e.preventDefault(); checkInsurance()} }>Return to Booking Summary</a>
	        </div>
        </div>
        
        <div id="message6" class="wth2-errorMessage wth2-errorMessageHeader" style={message6DisplayProperty}>
        		<i class="fa fa-exclamation-circle" aria-hidden="true"></i> We are experiencing technical difficulties. Please try your request in 20 minutes. Please call {props.siteConfigData.cruisePhone} to speak to a customer service agent for information about your trip. Customer service agents are available {props.siteConfigData.operationHrs}.
        	</div>
        
        <div id="css_paymentFormError" class="wth2-errorMessage" style={{display:'none'}}>
        	<i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        	<div class="wth2-errorMessageHeader" id="css_paymentErrorHeader"> Please complete the required fields.</div>
        	<div id="css_paymentErrorMessage_validPaymentAmount" class="wth2-formErrorMessage" style={{display:'none'}}> Enter valid payment amount </div>
        	<div id="css_paymentErrorMessage_validPaymentChoice" class="wth2-formErrorMessage" style={{display:'none'}}> Choose a payment amount </div>
        	<div id="css_paymentErrorMessage_validPaymentAmountTooMuch" class="wth2-formErrorMessage" style={{display:'none'}}> Enter payment amount equal to or less than <NumberFormat value={payRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /> </div>
        	<div id="css_paymentErrorMessage_validPaymentAmountTooLittle" class="wth2-formErrorMessage" style={{display:'none'}}> Enter payment amount of <NumberFormat value={minimumPaymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /> or greater</div>										
        	<div id="css_paymentErrorMessage_validStreetAddress1" class="wth2-formErrorMessage" style={{display:'none'}}>Enter valid street address 1 </div>
        	<div id="css_paymentErrorMessage_validStreetAddress2" class="wth2-formErrorMessage" style={{display:'none'}}>Enter valid street address 2 </div>
        	<div id="css_paymentErrorMessage_validCity" class="wth2-formErrorMessage" style={{display:'none'}}>Enter valid city </div>
        	<div id="css_paymentErrorMessage_selectState" class="wth2-formErrorMessage" style={{display:'none'}}>Select state </div>
        	<div id="css_paymentErrorMessage_validZip" class="wth2-formErrorMessage" style={{display:'none'}}>Enter valid 5-digit U.S. Zip Code </div>
        	<div id="css_paymentErrorMessage_selectCreditCardHolder" class="wth2-formErrorMessage" style={{display:'none'}}>Select credit card holder </div>
        	<div id="css_paymentErrorMessage_selectBillingAddress" class="wth2-formErrorMessage" style={{display:'none'}}>Select billing address </div>
        	<div id="css_paymentErrorMessage_validcreditcardnumber" class="wth2-formErrorMessage" style={{display:'none'}}> Enter valid credit card number</div>	
        	<div id="css_paymentErrorMessage_validcccvv" class="wth2-formErrorMessage" style={{display:'none'}}> Enter valid CVV number</div>
        	<div id="css_paymentErrorMessage_requiredcccvv" class="wth2-formErrorMessage" style={{display:'none'}}> Enter a CVV number</div>
        	<div id="css_paymentErrorMessage_selectExpDate" class="wth2-formErrorMessage" style={{display:'none'}}>Select expiration date </div>
        	<div id="css_paymentErrorMessage_5dayExpDate" class="wth2-formErrorMessage" style={{display:'none'}}>Your card will expire within 5 days. Please use another card or call {props.siteConfigData.cruisePhone} to make a payment.</div>
        	<div id="css_paymentErrorMessage_selectInsurance" class="wth2-formErrorMessage" style={{display:'none'}}>Select an option for Travel Insurance </div>
        </div>
        
        <div class="wth2-cssMainContainer">
	    	<div class="wth_css_headContainer"><span class="wth2_css_headdesc" id="css_summaryOfChargesHeader">Summary of Charges:</span> </div>
	    	<div class="wth2_css_chargesContainer">
	    		<div class="wth2_css_paymentLine"><span class="wth2_css_headdesc" id="css_charges_totalCostLabel">Total:</span></div><div class="wth2_css_paymentLine2"><span id="css_chargesTotalCost" ><NumberFormat value={totalcost} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span></div><br />
	    		<div class="wth2_css_paymentLine"><span class="wth2_css_headdesc" id="css_charges_travelProtectionLabel">Travel Insurance:</span></div><div class="wth2_css_paymentLine2"><span id="css_chargesTravelProtection">{insuranceStatus}</span></div>
	    		{props.updateBooking.bookingSummary.charges.insurance.hasOwnProperty('vendor') &&
	    			props.updateBooking.bookingSummary.charges.insurance.vendor.name.indexOf('BERKELY') === -1 &&
	    			<div class="wth2_css_insuranceVendor"><span class="wth3-insuranceProvider" id="insuranceProvider">{insuranceVendor}</span><br /></div>
	    		}

	    		<br />
	    		
	    		<div class="wth2_css_paymentLine"><span class="wth2_css_headdesc" id="css_charges_paymentsToDateLabel">Amount Paid:</span></div>
	    		<div class="wth2_css_paymentLine2"><span id="css_chargesPaymentsToDate">
		    		{props.updateBooking.bookingSummary.charges.paymentsToDate!==0 &&
		    			<span>-<NumberFormat value={props.updateBooking.bookingSummary.charges.paymentsToDate} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
		    		}
		    		{props.updateBooking.bookingSummary.charges.paymentsToDate===0 &&
		    			<span><NumberFormat value={props.updateBooking.bookingSummary.charges.paymentsToDate} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
		    		}
	    		</span>
	    		</div><br />
	    		<div class="wth2_css_paymentLine wth2_css_amountPaidTotal">
	    			{(remainingBalanceNegative===true||props.updateBooking.bookingSummary.charges.remainingBalance===0||remainingBalance===0) &&
	    			<span class="wth2_css_headdesc" id="css_paidInFull">{paidInFullLanguage}</span>
	    			}
	    			<span class="wth2_css_headdesc" id="css_balanceDueLabel">{balanceDue}</span>
	    		</div>
	    		<div class="wth2_css_paymentLine2 wth2_css_amountPaidTotal">
	    			{remainingBalanceNegative===false && remainingBalance!==0 &&
	    				<span id="css_chargesRemainingBalance" ><NumberFormat value={remainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
	    			}
	    		</div>
	    		{bookingPastDue===false && remainingBalance!==0 && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking River' && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking Ocean' &&
	    			<div id="css_paymentDueDate" class="wth2-css_paymentDueDate wth2_css_amountPaidTotal">{paymentDue}</div>
	    		}
	    		{!remainingBalanceNegative && props.updateBooking.bookingSummary.charges.remainingBalance!=='0.0' && remainingBalance!==0 && bookingPastDue === true &&
				props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking River' && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking Ocean' &&
	    			<div id="css_paymentDueDate" class="wth2-css_paymentDueDatePast wth2_css_amountPaidTotal">Payment was due on {getFormattedDate(props.updateBooking.bookingSummary.charges.paymentDueDate)}</div> 
	    		}
	    		<div class="wth2_css_scheduledPaymentsContainer" id="css_scheduledPaymentsContainer">
	    			{//eslint-disable-next-line
					props.updateBooking.futurePayments!=null && props.updateBooking.futurePayments!='' &&
	    			<div class="wth2_css_headdesc" id="css_scheduledPaymentsHeader">Scheduled Payments (<span id="css_scheduledPaymentsTotal"><NumberFormat value={props.updateBooking.bookingSummary.charges.scheduledPayment} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span> in total):</div>
	    			}
	    			{props.updateBooking.futurePayments.map((futurepayments, index, arr)=>(
	    			<div id={"css_futurePayment_" + index}><span id={"css_futurePayment" + index + "_amount"}><NumberFormat value={futurepayments.amount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span> on <span className="css_futurePaymentCCType" id={"css_futurePayment" + index + "_cctype"}>{futurepayments.creditCardType.replace("(R)", "\u00AE ").toLowerCase()}</span> ending in <span id={"css_futurePayment" + index + "_ccnum"}>{futurepayments.maskedCreditCardNumber.slice(-4)}</span> on <span id={"css_futurePayment" + index + "_fpdate"}>{futurepayments.futurePaymentDate}</span></div>
	    			))}
	    		</div>
	    	</div>
	    	{props.updateBooking.makePayment.paymentOptions.futurePaymentsRemoved===true &&
	    	<div class="">
	    		<div id="scheduledPaymentWiseMessageWraper" class="scheduledPaymentWiseMessageWraper wth2-warningMessage" aria-hidden="true">
	    			<i class="fa fa-exclamation-circle " aria-hidden="true"></i>
	    			<div id="scheduledPaymentWiseMessageHeader" class="wth2-warningMessageHeader">Please Note:</div>
	    			<div id="scheduledPaymentWiseMessageText">Some payments that are scheduled to be paid in the next 5 days may not be paid online now.</div>		
	    		</div>						
	    	</div>
	    	}
	    	{(remainingBalance<25 || props.updateBooking.makePayment.remainingBalance<25) && (css_ins==='N' || css_ins==='' || css_ins===null) &&
			<div class="">
	    		<div id="lessThan25MessageWraper" class="lessThan25MessageWraper wth2-informationMessage" aria-hidden="true">
	    			<i class="fa fa-info-circle" aria-hidden="true"></i>
	    			<div id="lessThan25WiseMessageHeader" class="wth2-informationMessageHeader">Please Note:</div>
	    			<div id="lessThan25WiseMessageText">Balances below $25.00 cannot be paid online. To complete your payment, please call us at {props.siteConfigData.cruisePhone}.</div>		
	    		</div>						
			</div>
	    	}
	    </div>
	    </div>

        <div id="css_payment_FormContainer">
        <form name="css_payment" id="css_payment" novalidate>
        	<input type="hidden" value={props.updateBooking.bookingNumber} name="bookingNumber"/>
	        {props.updateBooking.bookingSummary.quoteInsuranceInd==='Y' && props.updateBooking.insuranceQuote.priceAmount!=='' &&
        	<div>
	        	<div class="wth2-cssMainContainer wth2-css_Line">
	        		<div class="wth_css_headContainer"><span id="css_liesureCare" class="wth2_css_headdesc"><i class="fa fa-shield" aria-hidden="true"></i> LeisureCare Travel Insurance (Recommended):</span></div>
	        		<div id="css_insuranceText2">
	        			<div id="css_insuranceLifetime" class="wth2_css_headdesc">You've planned the cruise of a lifetime. Now plan ahead for life's uncertainties.</div>
	        			Add LeisureCare Travel Insurance to your booking for coverage of:
	        		</div>
	        		
        			<div class="wth2-css_InsuranceContainer">
        				<div class="wth2-css_insBullets">
	        				<div id="css_insuranceBullet1" class="wth2-css_insuranceLine"><i class="fa fa-check" aria-hidden="true"></i>Up to 100% of your trip cost if you need to <span class="wth2-bold"> cancel </span>due to illness, injury or other covered reasons</div>
	        				<div id="css_insuranceBullet2" class="wth2-css_insuranceLine"><i class="fa fa-check" aria-hidden="true"></i>Up to 100% of your trip cost if you need to <span class="wth2-bold">start late or come home early</span> due to illness, injury or other covered reasons</div>
	        				<div id="css_insuranceBullet3" class="wth2-css_insuranceLine"><i class="fa fa-check" aria-hidden="true"></i>Up to $1,000 for covered <span class="wth2-bold">trip delays</span></div>
	        				<div id="css_insuranceBullet4" class="wth2-css_insuranceLine"><i class="fa fa-check" aria-hidden="true"></i>Up to $1,000 for <span class="wth2-bold">missed flight connections</span></div>	
        				</div>			
        				<div class="wth2-css_insBullets">
	        				<div id="css_insuranceBullet5" class="wth2-css_insuranceLine"><i class="fa fa-check" aria-hidden="true"></i>Up to $1,500 for <span class="wth2-bold">lost, stolen or damaged baggage</span></div>	
	        				<div id="css_insuranceBullet6" class="wth2-css_insuranceLine"><i class="fa fa-check" aria-hidden="true"></i>Up to $500 for necessary personal articles if your <span class="wth2-bold">bags are delayed</span></div>
	        				<div id="css_insuranceBullet7" class="wth2-css_insuranceLine"><i class="fa fa-check" aria-hidden="true"></i>Up to $50,000 for covered <span class="wth2-bold">medical expenses</span> if you get injured or ill on vacation</div>
	        				<div id="css_insuranceBullet8" class="wth2-css_insuranceLine"><i class="fa fa-check" aria-hidden="true"></i>Up to $50,000 for a covered <span class="wth2-bold">emergency medical evacuation</span></div>
        				</div>
        			</div>	
        			<div class="wth2-css_insurSelectContainer">
        				<div id="css_travelProtectionOptionLabel" class="wth2_css_headdesc">Please select an option:</div>
        				<div class="wth2-css_radioBtn" id="css_insuranceChoice">
        				    <fieldset class="wth2-radioBtn wth2-radioBtnVertical">
        						<label id="css_insuranceYesLabel" for="css_yes_insurance" class="wth2-css_insuranceRadio wth2-css_radio wth2_css_radio_notselected"><input onClick={() => {changeInsuranceChoice('yes')}} id="css_yes_insurance" type="radio" name="css_ins" value="Y"/><span></span>Yes, include LeisureCare Travel Insurance for <span id="css_ins_perpersonnight_price"><NumberFormat value={props.updateBooking.insuranceQuote.priceAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span></label>
        						<label id="css_insuranceNoLabel" for="css_no_insurance" class="wth2-css_insuranceRadio wth2-css_radio wth2_css_radio_notselected"><input onClick={() => {changeInsuranceChoice('no')}} id="css_no_insurance" type="radio" name="css_ins" value="N"/><span></span>No, thank you. I choose to travel without insurance.</label>
        					</fieldset>	
        				</div>
        				<div id="css_travelProtectionDisclaimer" class="travelProtectionDisclaimer">*Plan cost amounts are subject to change without notice. Don’t Delay, Add LeisureCare Today!</div>
        				<div class="css_insuranceTerms">
        					<div id="css_insPDF" class="wth2_css_headdesc css_insRemainingBalancePDF" ><a id="css_insPDFLink" href={props.updateBooking.insuranceQuote.insurancePdf} target="_blank" rel="noopener noreferrer"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> View terms, conditions and plan sponsors</a></div>
        					<div id="css_insRemainingBalance" class="css_insRemainingBalanceAnnouncement">{insuranceBalanceNote} <NumberFormat value={remainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></div>
        					<div id="message8" class="wth2-warningMessage" style={message8DisplayProperty}><span class="wth2-warningMessageHeader"><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Please Note:</span><br/>Travel insurance will be added to your booking once the LeisureCare plan cost is paid in full. Please make a minimum payment to continue.</div>
        				</div>
        			</div>
	        	</div>
	        </div>
	        }

	        {payRemainingBalance>=25 &&
		        <div class="wth2-cssMainContainer">
		        	<div class="wth_css_headContainer"><span id="css_amountToPayHeader" class="wth2_css_headdesc"><i class="fa fa-credit-card" aria-hidden="true"></i> Payment Information</span></div>
		        	<div class="wth2_css_paymentInformationContainer">
		        		<div id="css_amountToPayText"><span class="wth2_css_headdesc">Amount to Pay Today</span></div>
		        		{remainingBalance<25 &&
			        		<div>
			        			<div id="css_paymentDueTooSmall" class="wth2-informationMessage wth2-informationMessageHeader"><i class="fa fa-phone-square" aria-hidden="true"></i> {props.updateBooking.makePayment.message}</div>
			        		</div>
		        		}
		        		<fieldset class="wth2-radioBtn wth2-radioBtnVertical" id="css_paymentChoiceContainer">
		        			{props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments>=25 && remainingBalance>=25 && bookingPastDue===false &&
		        			<label onClick={() => {changePaymentChoiceFull()}} id="css_remainingBalancePaymentLabel" for="css_remainingBalancePayment" class="wth2-css_radio wth2_css_radio_notselected"><input id="css_remainingBalancePayment" onClick={() => {changePaymentChoiceFull()}} type="radio" name="paymentOption"  value="Full"/><span>Pay Remaining Balance: <NumberFormat value={payRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
		        				{paymentDue!=='' && paymentDue!==null && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking River' && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking Ocean' &&
		        				<span> - <span id="css_dueMessage">{paymentDue}</span></span>
		        				}</span>
		        			</label>
		        			}
		        			{props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments>=25 && remainingBalance>=25 && bookingPastDue===true && 
		        			<label onClick={() => {changePaymentChoiceFull()}} id="css_remainingBalancePaymentLabel" for="css_remainingBalancePayment" class="wth2-css_radio wth2_css_radio_notselected"><input id="css_remainingBalancePayment" onClick={() => {changePaymentChoiceFull()}} type="radio" name="paymentOption" value="Full"/><span>Pay Remaining Balance: <NumberFormat value={payRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /> {props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking River' && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking Ocean' && <span id="css_pastDueMessage" class="wth2-errorMessageHeader"> - Balance is past due </span>}</span></label>
		        			}
		        			{props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments>=25 && remainingBalance>=25 && bookingPastDue===false && minimumPaymentAmount!==payRemainingBalance &&
		        			<label onClick={() => {changePaymentChoiceOther()}} id="css_otherAmountPaymentLabel" class="wth2-css_radio wth2_css_radio_notselected" for="css_otherAmountPayment"><input id="css_otherAmountPayment" onClick={() => {changePaymentChoiceOther()}} type="radio" name="paymentOption" value="Other"/><span>Pay other amount: $<input type="text" size="10" name="paymentOther" onChange={() => {otherAmountChange()}} onBlur={() => {otherAmountChange()}} onClick={() =>{clearOtherField()}} id="otherAmountPaymentInputField" class="form-control wth2-inputText"/> <span id="css_otherAmountHelper" class="wth2-css_helper">(Payment must be between <NumberFormat value={minimumPaymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /> and <NumberFormat value={payRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />)</span></span></label>
		        			}
		        			{((props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments===0 && remainingBalance>=25 && props.updateBooking.bookingSummary.quoteInsuranceInd==='Y') || (props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments<25 && css_ins==='Y')) &&
		        			<label onClick={() => {changePaymentChoiceFull()}} id="css_remainingBalancePaymentLabel" for="css_remainingBalancePayment" class="wth2-css_radio wth2_css_radio_notselected"><input id="css_remainingBalancePayment" onClick={() => {changePaymentChoiceFull()}} type="radio" name="paymentOption" value="Full"/><span>Pay Remaining Balance: <NumberFormat value={payRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
		        				{paymentDue!=='' && paymentDue!==null && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking River' && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking Ocean' &&
		        				<span className='payment_due'>- <span id="css_dueMessage">{paymentDue}</span></span>
		        				}
		        			</label>
		        			}
		        		</fieldset>	
			        </div>
			    </div>
        	}
			{payRemainingBalance>=25 &&
	        <div class="wth2-cssMainContainer">
	        	<div class="wth_css_headContainer"><span id="css_ccInfoHeader" class="wth2_css_headdesc">Credit Card Information</span></div>
	        	<div class="wth2_css_paymentInformationContainer">
	        		<div id="css_ccHolderContainer" class="wth2-css_ccInfoLine wth2-selectWrapper wth2-selectLarge">
	        			<label for="customerNumber"><span id="css_ccHolderLabel" class="wth2_css_headdesc">Credit Card Holder:</span></label>
	        			<div class="wth2-selectWrap">
		        			<select name="customerNumber" id="customerNumber" onChange={() => {ccHolderOnChange()}} class="form-control wth3-customerNumberSelection">
		        				<option id="chooseGuest" value="">Please select a cardholder</option>
		        				{props.updateBooking.makePayment.creditCardHolderList.map((guest, index, arr)=>(
		        				<option className="customerNumberOptionItem" disabled={!guest.creditCardHolder} value={guest.customerNumber} id={"css_paxChoice_" + guest.customerNumber}>{noCase(guest.firstName)} {noCase(guest.lastName)}</option>
		        				))}
		        			</select>
	        			</div>
	        		</div>
	        		{showOtherInputFields &&
	        		<div class="wth2-css_ccInfoLine wth2-css_billingAddressForm" id="css_otherInputFields">
	        			<div id="css_otherFirstName" class="wth2-css_firstNameOther wth2_css_headdesc"><label for="css_cc_otherFirstName">First Name:</label><input type="text" class="wth2-inputText" id="css_cc_otherFirstName" name="otherFirstName"/></div>
	        			<div id="css_otherMILabel" class="wth2-css_MIOther wth2_css_headdesc"><label for="css_cc_otherMI"><span aria-hidden="true">M.I. </span><span class="visuallyhidden">Middle Initial </span>(Optional):</label><input type="text" class="wth2-inputText" id="css_cc_otherMI" name="otherMI"/></div>
	        			<div id="css_otherLastNameLabel" class="wth2-css_lastNameOther wth2_css_headdesc"><label for="css_cc_otherLastName">Last Name:</label><input type="text" class="wth2-inputText" id="css_cc_otherLastName" name="otherLastName"/></div>
	        		</div>
	        		}
	        		<div class="wth2-css_ccInfoLine wth2-css_billingAddressForm" id="css_ccInformationSection">
	        			<div id="css_ccNumberLine" class="wth2-css_ccNumberField wth2_css_headdesc"><label for="token" id="css_ccLabel">Credit Card Number:</label><input type="text" id="token" name="token" class="form-control wth2-inputText wth2-css_creditCardEntryField"/></div> 
	        			<fieldset id="css_ccExprLine" class="wth2-selectWrapper wth2-creditCardExpWrapper wth2-css_ccExpDate wth2_css_headdesc">
	        				<legend tabindex="-1">Expiration Date:</legend>
	        				<div id="css_ccExpMonthContainer" class="wth2-creditCardExpMonth">
	        					<label class="visuallyhidden" for="ccMonth">Month</label>
	        					<div class="wth2-selectWrap"><select type="text" id="ccMonth" name="ccMonth" class="form-control wth2-inputText" onChange={()=> {popYear()}}>
	        						<option value="">Month</option>
	        						<option value="01">01</option>
	        						<option value="02">02</option>
	        						<option value="03">03</option>
	        						<option value="04">04</option>
	        						<option value="05">05</option>
	        						<option value="06">06</option>
	        						<option value="07">07</option>
	        						<option value="08">08</option>
	        						<option value="09">09</option>
	        						<option value="10">10</option>
	        						<option value="11">11</option>
	        						<option value="12">12</option>
	        					</select></div>	
	        				</div>
	        				<div id="css_ccExpYearContainer" class="wth2-creditCardExpYear">
	        					<label class="visuallyhidden" for="ccYear">Year</label>			
	        					<div class="wth2-selectWrap"><select type="text" id="ccYear" name="ccYear" class="form-control wth2-inputText">
	        						<option value="" class="wth-css-dropdownPlaceholder">Year</option>	
	        					</select></div>
	        				</div>
	        			</fieldset>	
	        			<div id="css_ccCVVLine" class="wth2-css_ccCVVField wth2_css_headdesc"><label for="css_cccvv" id="css_cccvvLabel">CVV: {Tooltip}</label><input type="text" id="css_cccvv" name="css_cccvv" class="form-control wth2-inputText wth2-css_creditCardCvvField"/></div> 		
	        		</div>
	        		<div class="wth2-css_ccIconsLine" id="css_ccIcons">
	        			<i class="fa fa-cc-visa wth2-creditCardIcons" id="visaIcon" aria-hidden="true"></i><i class="fa fa-cc-mastercard wth2-creditCardIcons" id="mastercardIcon" aria-hidden="true"></i><i class="fa fa-cc-discover wth2-creditCardIcons" id="discoverIcon" aria-hidden="true"></i><i class="fa fa-cc-amex wth2-creditCardIcons" id="amexIcon" aria-hidden="true"></i>
	        		</div>
	        		{showBillingAddressDrop &&
	        		<div class="wth2-css_ccInfoLine" id="css_BillingAddressDrop">
	        			<label for="customerAddressNumber"><span id="css_ccBillingAddressLabel" class="wth2_css_headdesc">Billing Address:</span></label> 
	        			<div class="wth2-selectWrap"><select name="customerAddressNumber" id="customerAddressNumber" onChange={() => {ccBillingAddressOnChange(document.getElementById("customerAddressNumber").value)}} class="form-control"><option value='' selected='selected'>Choose billing address</option></select></div>
	        		</div>
	        		}
	        		{showBillingAddressFields &&
	        		<div id="css_BillingAddressFields">
	        			<div class="wth2-css_ccInfoLine wth2-css_billingAddressForm">
	        				<div id="css_address1Container" class="wth2-css_address1 wth2_css_headdesc">
	        					<label for="css_address1"><span id="css_paymentAddress1Label">Street Address 1:</span></label>
	        					<input id="css_address1" name="css_address1" class="form-control wth2-inputText" type="text" placeholder="" maxlength="30" size="30" minlength="2"/>
	        					<div id="css_addressHelper" class="wth2-css_addressHelper">May contain special characters:  -  '  .  #</div>
	        				</div>
	        				<div id="css_address2Container" class="wth2-css_address2 wth2_css_headdesc">
	        					<label for="css_address2"><span id="css_paymentAddress2Label">Street Address 2: (Optional)</span></label>
	        					<input id="css_address2" name="css_address2" type="text" class="form-control wth2-inputText" placeholder="" size="30" maxlength="30" minlength="2" pattern="/^[ A-Za-z0-9.#'-]*$/" />
	        					<div id="css_addressHelper2" class="wth2-css_addressHelper">May contain special characters:  -  '  .  #</div>
	        				</div>
	        				<div id="css_cityContainer" class="wth2-css_city wth2_css_headdesc">
	        					<label for="css_city"><span id="css_paymentCityLabel">City:</span></label>
	        					<input id="css_city" name="css_city" type="text" class="form-control wth2-inputText" placeholder="" maxlength="30" size="30" minlength="2" />
	        				</div>
	        				<div id="css_stateContainer" class="wth2-css_state wth2_css_headdesc wth2-selectWrapper">
	        					<label for="css_paymentState"><span id="css_paymentStateLabel">State:</span></label>
	        					<div class="wth2-selectWrap">
	        					<select id="css_paymentState" name="css_paymentState" class="form-control"></select>
	        					</div>
	        				</div>
	        				<div id="css_zipContainer" class="wth2-css_zip wth2_css_headdesc">
	        					<label for="css_zip"><span id="css_paymentZipCode">Zip Code:</span></label>
	        					<input id="css_zip" name="css_zip" type="text" class="form-control wth2-inputText" placeholder="" maxlength="5" size="5" minlength="5"/>
	        					<div id="css_zipHelper" class="wth2-css_zipHelper">5-digit U.S. Zip Code</div>
	        				</div>	
	        							
	        			</div>
	        		</div>
	        		}
	        	</div>
	        	<div class="wth2-css_debitNote" id="css_debitNote">
	        		<span class="wth2-bold">Please note:</span> If you are using a debit card or a Visa check card, please call your bank to see if you have a daily transaction limit before continuing to make a payment.
	        	</div>
	        	<input type='hidden' id="paymentAmount" name="paymentAmount" value={paymentAmount}/>
	        	<div id="css_amountPaidContainer" class="wth2_css_headdesc" style={{display:"none"}}>Amount that will be charged to your card: <span id="css_paymentAmountDisplay">{paymentAmount}</span></div>
	        	<div id="css_termsCondStatement" class="wth2-css_tandc">
	        		By submitting this payment, I understand and accept all associated Terms and Conditions. I accept the restrictions and penalties of this fare. I also understand that cancellation fees may apply.
	        		<div class="wth2-css_viewTerms">{Tooltip2}</div>
	        	</div>	
	        </div>
	        }
	        {payRemainingBalance>=25 &&
	        <div id="css_submitButtonContainer" class="wth2-css_submitButtonContainer">
	        	<a href="# " id="cssSubmitButton" class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-ui-btn" onClick={e => {e.preventDefault(); paymentFormValidationSubmit()}}>Complete Payment</a>
	        </div>
	        }
        </form>
        </div>       
    </div>; 
}

export default PaymentView;